var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatFigurePass1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 676 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.59,146.57c0-2.36.65-3.66-1.39-6.19s-12-15.14-13.6-18.16S366,104.31,363.86,99.67s-5.14-10.1-6.11-12.38-2-4.16-5-5.46-8.63-3.34-10.91-4.07-3.91-1.47-6.6-.49-10.1,3.42-12,4.4-3.58,1.79-4.8,4.48-7.25,14.41-10.59,21.33-5.62,12.54-6.6,14.34a64.21,64.21,0,0,1-5,7.16c-2.37,3.1-7.66,10.26-8.64,11.4a7,7,0,0,0-1.79,5.05c0,2.61-.49,15.39-.65,17.67a18.6,18.6,0,0,1-1.22,6.11c-.9,2.36-1.39,3.34-2,5a11.93,11.93,0,0,0-1,5.21c0,2.44-.41,18.81-.49,27.44s-.57,28.5-1,34.2-1.55,18.73-2.44,25.09-3.34,26.54-4.32,34.12-3,17.5-3.58,20.27-3.34,21.34-3.67,28-.32,10.75,1.22,13.19,7.33,10.34,13,14.17,19.14,11.4,35.92,13a207.54,207.54,0,0,0,46.9-.74c14.74-1.87,30.38-9.52,35.43-14a67.11,67.11,0,0,0,10.66-11.89c1.14-2,2-3.75,1.8-7.9s-3.34-30.78-4.4-36.56-2.69-15.15-3.42-21-2.93-24.19-4-31.68-2.45-21.42-2.45-27.36-.81-29.16-.89-34.86-.73-20.6-.82-23.21-.08-5.13-1.3-7.49-3.42-7.9-3.42-12.29S389.59,146.57,389.59,146.57Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 363.86,
    y1: 357.2,
    x2: 346.66,
    y2: 370.65,
    gradientTransform: "matrix(1.03, 0.61, -0.8, 0.79, 279.79, -144.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 365.14,
    y1: 421.23,
    x2: 374.66,
    y2: 395.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c7bdba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c7bdba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa3c3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 365.36,
    y1: 421.21,
    x2: 374.44,
    y2: 395.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#938b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#938b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa3c3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 384.97,
    y1: 400.68,
    x2: 408.34,
    y2: 369.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#aa3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c7bdba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c7bdba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#aa3c3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 384.62,
    y1: 401.13,
    x2: 408.67,
    y2: 369.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#aa3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#938b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#938b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#aa3c3c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.75,77.37a6.62,6.62,0,0,0-2.28.44c-.74.27-1.83.65-3.06,1.07-3.17,1.1-7.52,2.61-8.84,3.3l-.2.1c-1.75.91-3.25,1.69-4.35,4.11-.6,1.32-2.36,4.82-4.39,8.87s-4.5,8.95-6.2,12.47c-1.82,3.78-3.36,7.23-4.48,9.75-1,2.19-1.68,3.78-2.13,4.61a65.21,65.21,0,0,1-5.1,7.24c-.88,1.15-2.17,2.87-3.49,4.64-2.23,3-4.54,6.06-5.16,6.79a6.29,6.29,0,0,0-1.65,4.67c0,2.6-.49,15.37-.66,17.71a19,19,0,0,1-1.25,6.27c-.56,1.47-.95,2.39-1.34,3.29-.23.54-.45,1.07-.7,1.69a11.33,11.33,0,0,0-.94,5c0,1-.07,4.48-.16,8.84-.12,6.06-.28,13.6-.33,18.61-.08,8.91-.57,28.6-1,34.24-.38,5.31-1.52,18.57-2.44,25.12-.57,4-1.74,13.47-2.78,21.84-.61,4.92-1.18,9.46-1.54,12.27-.45,3.52-1.44,9.89-3.59,20.32-.52,2.53-3.33,21.25-3.65,27.93-.3,6-.39,10.46,1.13,12.85,1.25,2,7.09,10.12,12.86,14a80.55,80.55,0,0,0,35.65,12.94,207.55,207.55,0,0,0,46.78-.74c14.64-1.86,30.06-9.38,35.11-13.86A67,67,0,0,0,408.15,362c1.1-1.89,1.87-3.54,1.71-7.59-.17-4.31-3.37-30.91-4.39-36.48-.59-3.21-2.57-14.21-3.42-21-.18-1.42-.44-3.56-.75-6.1-1-7.92-2.44-19.89-3.24-25.57-1-7.07-2.45-21.27-2.45-27.44,0-3.48-.28-12.9-.53-21.22-.17-5.79-.33-11.26-.37-13.63,0-4.07-.4-12.75-.63-18.49-.09-2.23-.16-4-.18-4.71v-.47c-.08-2.4-.14-4.67-1.23-6.77-1.2-2.33-3.48-8-3.48-12.56,0-4.35-.17-13.26-.17-13.35h0c0-.5,0-.95.06-1.38a5.21,5.21,0,0,0-1.31-4.45c-1.44-1.77-11.93-15.05-13.66-18.24-1.61-3-8.63-17.9-10.77-22.6-1.13-2.48-2.51-5.17-3.73-7.55-1-2-1.92-3.76-2.38-4.84-.89-2.08-1.86-3.9-4.67-5.15-3-1.32-8.72-3.37-10.86-4l-.63-.21A10.37,10.37,0,0,0,337.75,77.37Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 301.32,
    cy: 381.04,
    r: 3.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ffdf5d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 295.95,
    cy: 382.66,
    r: 2.63,
    gradientTransform: "translate(23.09 -16.8) rotate(3.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ffdf5d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 309.33,
    cy: 382.54,
    r: 4.27,
    gradientTransform: "translate(13.23 -10.33) rotate(1.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffdf5d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 302.77,
    cy: 383.42,
    r: 4.42,
    gradientTransform: "translate(25.56 -18.86) rotate(3.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ffdf5d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 306.98,
    cy: 379.97,
    r: 3.33,
    gradientTransform: "translate(23.45 -17.8) rotate(3.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ffdf5d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 297.1,
    cy: 385.62,
    r: 2.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffdf5d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 300.96,
    cy: 117.2,
    r: 3.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d39d79"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 295.59,
    cy: 118.82,
    r: 2.63,
    gradientTransform: "translate(7.53 -17.23) rotate(3.38)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 308.97,
    cy: 118.7,
    r: 4.27,
    gradientTransform: "translate(4.23 -10.47) rotate(1.96)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 302.4,
    cy: 119.57,
    r: 4.42,
    gradientTransform: "translate(8.41 -19.4) rotate(3.73)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 306.61,
    cy: 116.13,
    r: 3.33,
    gradientTransform: "translate(7.57 -18.26) rotate(3.45)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 296.73,
    cy: 121.78,
    r: 2.74,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.04,
    cy: 60.7,
    r: 27.1,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pass1bTissues"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body_Exterior",
    "data-name": "Body Exterior"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.36,85.82c1.7-.81,2.12-2.69-.08-2.85s-5.29,0-5.94-.49a6.19,6.19,0,0,0-5.13-.08c-2.28.9-3.67.65-5.7,1.79s-5.13,7.82-6.76,12.54a86.18,86.18,0,0,0-11.16,11.4c-5.45-1-16-4.72-19.46-8.63,7.35-.69,6.31-6.49,5.29-8.87-.87-2-8.14-11.4-12.46-13.52,0-12.46-.32-14.9-4.64-24.19s-6.92-13-7.82-20.11-5.21-18.65-9.12-23.54c-.94-1.18-1.82-2.2-2.66-3.07l-.38,0a17.06,17.06,0,0,0-7.24,3.27l-.33.31-.35-.3a14,14,0,0,0-7.18-3.1l-.44,0A20.22,20.22,0,0,0,327,9.68c-2.61,3.83-8.39,15.39-8.88,23.86s-6.84,17.27-9,22-3.34,14.41-3.58,21.58c-9.45,5.7-20,22-6.92,22.07a57.75,57.75,0,0,1-19.3,9.36c-3.67-4.56-9.61-10.83-10.92-11.24-2.11-9.77-9.44-18.64-18.89-14.41-5.7-1.06-7.82,1.3-5,3.66-2.11,0-1.95,1.55-.57,2-.36,1.79.9,2.44,5,2.85-.24,2.52,0,4.64,2.45,5.46,2.68,3.25,4.23,5.29,6.84,14.16s5.78,21.18,6.84,24,5,8.79,7.33,13,5.45,8.38,5.29,15.55-2.3,36.07-3.31,45.93-3.45,37.78-4,48.21-2.61,35.42-2.93,41.77a98.35,98.35,0,0,1-3.26,18.81c-1.3,4.73-4.89,27.53-4.72,36.24s5,24.59,11.89,32.17,21.58,20.11,23.37,22.64,3.17,5.13,3.17,6.92-.32,5.13-5,8.79A146.48,146.48,0,0,1,280,433.38a16.58,16.58,0,0,0-7.33,7.9c-2.52,5.05-6.35,10.73-3.5,12.21-2.18,4.72,0,5.85,2,2.85.31,2.2,1.59,1.66,2.61-.24.83-1.54,2.93-7.33,4.56-8.79s3.09-3.91,5.46-5.38a58.25,58.25,0,0,0-1.94,6.17c-.41,1.22,1,1.65,3-.47s5.54-7.65,8-9.85,11.07-7.66,16.53-10.83,7.33-5.46,7.16-6.6-2.77-1.87-4.31-2.28a3.38,3.38,0,0,1-2.45-4.15c.41-2.36,1.88-7.33,1.47-8.55a18.33,18.33,0,0,0-2.28-4.24c2.52-.24,5.46-1.22,6.84-3.82,3.18.24,8.06,1.05,9.28,5.37s3.18,18.08,4.81,24.59,5.53,15.88,13.11,19.87c5.84,3.08,14.66,2.24,21.5-.4a37.58,37.58,0,0,0,13.34-8.3c.26-.28.35-.36.59-.63-1.95-2.25-7.84-5.79-7.84-5.79l-.29.18a29.46,29.46,0,0,1-11.91,4.11c-4.4.25-11.4-1.22-13.19-8.14a44.75,44.75,0,0,1-1.06-18.65c.89-5.78,2.2-14.41,15.47-14.74-.41,5.05,4.15,6,7.41,6-2.28,2.36-2.93,4.64-2.44,6.92s1.3,6.76,1.14,7.9-.16,2.11-3,2.68-4.4,2-2.61,4.24,7.9,5.21,13,8.3a54.88,54.88,0,0,1,11.07,8.8c2.69,2.69,5.62,7.49,6.76,8.47s3.26,1.55,2.85-.41-1.71-3.66-2.11-5.62a25.89,25.89,0,0,1,7.41,9.29c1.14,2.6,2.43,5.28,3.17,6,1.06,1,2,1,2-1.4,1.48,3.54,4.72,3.48,2.11-2.61,1.33.47,1.27-1.55.53-4.32-.43-1.65-2.4-4.56-3.7-7.32a17.51,17.51,0,0,0-7.49-8.31c-4.48-2.69-10.35-6-12.79-8.23s-5.05-4.64-4.8-9.61,1.54-5.7,7.08-10.5,19-16.61,23-23.86,8.06-15.88,7.89-28.91-5.21-37.3-6.18-41.12-1.8-12.54-2.37-21.18-1.46-24.75-2.28-35-1.63-23.62-2.44-31.11-2.61-24-3.42-36.16-2.52-20.76-1.55-26.71,8-17.91,10.35-21.41,3.17-7.5,5.78-17,6.51-21.75,9.93-25.65c2.2-.66,2.53-4,2.53-5.62,3.09-.57,5.41-.09,5.45-2.53C433.32,87.86,433.77,86.41,431.36,85.82Z",
    fill: "#aa3c3c",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.89,421.43a61.39,61.39,0,0,0,11.85-21,59.29,59.29,0,0,0,7.57-7.69,78.23,78.23,0,0,1-13.42,33.62C387,425.65,383.48,422.72,382.89,421.43Z",
    fill: "#aa3c3c",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_Interior",
    "data-name": "Body Interior"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.59,146.57c0-2.36.65-3.66-1.39-6.19s-12-15.14-13.6-18.16S366,104.31,363.86,99.67s-5.14-10.1-6.11-12.38-2-4.16-5-5.46-8.63-3.34-10.91-4.07-3.91-1.47-6.6-.49-10.1,3.42-12,4.4-3.58,1.79-4.8,4.48-7.25,14.41-10.59,21.33-5.62,12.54-6.6,14.34a64.21,64.21,0,0,1-5,7.16c-2.37,3.1-7.66,10.26-8.64,11.4a7,7,0,0,0-1.79,5.05c0,2.61-.49,15.39-.65,17.67a18.6,18.6,0,0,1-1.22,6.11c-.9,2.36-1.39,3.34-2,5a11.93,11.93,0,0,0-1,5.21c0,2.44-.41,18.81-.49,27.44s-.57,28.5-1,34.2-1.55,18.73-2.44,25.09-3.34,26.54-4.32,34.12-3,17.5-3.58,20.27-3.34,21.34-3.67,28-.32,10.75,1.22,13.19,7.33,10.34,13,14.17,19.14,11.4,35.92,13a207.54,207.54,0,0,0,46.9-.74c14.74-1.87,30.38-9.52,35.43-14a67.11,67.11,0,0,0,10.66-11.89c1.14-2,2-3.75,1.8-7.9s-3.34-30.78-4.4-36.56-2.69-15.15-3.42-21-2.93-24.19-4-31.68-2.45-21.42-2.45-27.36-.81-29.16-.89-34.86-.73-20.6-.82-23.21-.08-5.13-1.3-7.49-3.42-7.9-3.42-12.29S389.59,146.57,389.59,146.57Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.45,47.62a3.23,3.23,0,0,1-1.53-.77V40.3a5.92,5.92,0,0,0-1.25-4.13c-1.11-1.58-7.88-10.09-8.84-11.11a2.79,2.79,0,0,0-2-1.06h0a2.81,2.81,0,0,0-2,1.06c-1,1-7.73,9.53-8.84,11.11a5.92,5.92,0,0,0-1.25,4.13v6.55a3.23,3.23,0,0,1-1.53.77.5.5,0,0,0,.08,1h.08a4.23,4.23,0,0,0,2.23-1.18l.36-.38c1.62-1.71,5.92-6.26,8.12-7.81a4.43,4.43,0,0,1,5.53,0c2.21,1.55,6.51,6.1,8.13,7.81l.35.38a4.22,4.22,0,0,0,2.24,1.18h.08a.5.5,0,0,0,.07-1Z",
    fill: "#8c1515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.92,45.82c-.85-.9-2.08-2.18-3.37-3.46l-.05,0-.51-.5-.14-.14-.43-.42-.17-.16-.39-.37-.19-.18-.36-.33-.2-.18-.34-.31-.2-.17-.33-.28-.17-.14-.34-.27-.14-.11-.43-.33a5.58,5.58,0,0,0-6.68,0l-.44.33-.14.11-.33.27-.18.14-.33.28-.19.17-.34.31-.2.18-.36.33-.19.18-.4.37a1.29,1.29,0,0,1-.17.16l-.42.42-.15.14-.5.5-.05,0c-1.29,1.28-2.52,2.56-3.38,3.46V40.3a5,5,0,0,1,1.07-3.56c1.21-1.71,7.91-10.09,8.75-11a1.94,1.94,0,0,1,1.29-.74,1.9,1.9,0,0,1,1.28.74c.85.91,7.55,9.29,8.75,11a5,5,0,0,1,1.07,3.56Z",
    fill: "#d36262"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Teeth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.63,27.2C340.47,25.77,339,24,337.78,24s-2.36,1.43-3.74,3.13c-.08.09-.22.24-.21.36s.17,2.43.23,4.18a1.81,1.81,0,0,0,1,1.63,2.22,2.22,0,0,0,1,.21,3.36,3.36,0,0,0,1.72-.54,3.3,3.3,0,0,0,1.72.54,2.21,2.21,0,0,0,1-.21,1.81,1.81,0,0,0,1-1.63c.06-1.75.23-4.16.24-4.18A.54.54,0,0,0,341.63,27.2Z",
    fill: "#8c1515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.27,26.49v5.67a1.89,1.89,0,0,1-1.74.28.82.82,0,0,1-.47-.77c-.05-1.47-.17-3.31-.22-3.92a14.74,14.74,0,0,1,2.44-2.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.49,31.67a.82.82,0,0,1-.46.77,1.9,1.9,0,0,1-1.75-.28V25.1a9.71,9.71,0,0,1,2.42,2.56C340.66,28.26,340.54,30.19,340.49,31.67Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nose"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.79,5.5l1.06.19a15.59,15.59,0,0,1,5.9,2.8,19.27,19.27,0,0,1,6.14-2.95l.93-.23a9.8,9.8,0,0,0-6.62-3.1C335.62,2.21,332.87,3.72,330.79,5.5Z",
    fill: "#d36262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.42,9.53l.35.3.33-.31a17.06,17.06,0,0,1,7.24-3.27l.38,0c-2.63-2.74-4.89-4-7.71-4-2.6,0-5.69,1.79-8.21,4.17l.44,0A14,14,0,0,1,337.42,9.53Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nose_Details",
    "data-name": "Nose Details"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.96,
    cy: 5.48,
    rx: 1.12,
    ry: 0.88,
    fill: "#890909"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.77,
    cy: 5.48,
    rx: 1.12,
    ry: 0.88,
    fill: "#890909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mouth_Nouse_Connector",
    "data-name": "Mouth & Nouse Connector"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.27,
    y: 9.41,
    width: 1,
    height: 15.01,
    fill: "#8c1515"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ears"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.06,80.65c-3.14,2.52-7.1,6.72-8.73,10.31-1.74,3.82-.95,5.49,1.6,5.35,3.3-.19,7.13-4.91,7.13-4.91C305,88.39,305.06,80.65,305.06,80.65Z",
    fill: "#932b2b",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.41,80.65c3.18,2.86,7.47,6.92,9.16,10.54,1.77,3.81.07,6.07-2.36,5.61-3.34-.64-6.8-5.32-6.8-5.32C370.45,88.47,370.41,80.65,370.41,80.65Z",
    fill: "#932b2b",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Esophagus"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.69,171.82c.44-3.66,2.67-10.56,4.25-16.3l-8.05-1c0,8.27,2,28.81,3.79,35.44C336.32,179.16,338.12,176.52,338.69,171.82Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.64,123.36c.12,2.81,2.44,19.89,1.83,25.28s-5.13,17.8-5.78,23.18c-.6,4.93-2.56,7.61.38,19.83a59.15,59.15,0,0,1,10.55,1.28,26.09,26.09,0,0,1-2.13-4c-1-2.28-2.2-9.21-2.2-13.93s1.22-23.23,1.38-26.35.08-6.95,2.61-10.13,1.3-6.43.89-8.23a50.21,50.21,0,0,1-1.38-7.32c-.08-2.53-2.2-3.91-3.83-7.33-1.31-2.74-2.25-27.51-2.57-37.7l-.52-.17c-2.25-.72-3.87-1.44-6.5-.52.23,10.42,1.89,40.51,2.63,41.36S341.45,122.27,342.64,123.36Z",
    fill: "#c7bdba",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Trachea"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M334,83.54a3.16,3.16,0,0,1,.17-5.46,5.14,5.14,0,0,1,5.57.7,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,83.54Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,78.17a3.16,3.16,0,0,1,.17-5.46,5.12,5.12,0,0,1,5.57.69,4.06,4.06,0,0,1,0,5.62A6.05,6.05,0,0,0,334,78.17Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,88.91a3.16,3.16,0,0,1,.17-5.46,5.14,5.14,0,0,1,5.57.7,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,88.91Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,94.29a3.16,3.16,0,0,1,.17-5.46,5.12,5.12,0,0,1,5.57.69,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,94.29Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,99.66a3.16,3.16,0,0,1,.17-5.46,5.12,5.12,0,0,1,5.57.69,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,99.66Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,105a3.16,3.16,0,0,1,.17-5.46,5.14,5.14,0,0,1,5.57.69,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,105Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,110.4a3.16,3.16,0,0,1,.17-5.46,5.14,5.14,0,0,1,5.57.7,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,110.4Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,115.77a3.16,3.16,0,0,1,.17-5.46,5.14,5.14,0,0,1,5.57.7,4.06,4.06,0,0,1,0,5.62A6.06,6.06,0,0,0,334,115.77Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,121.14a3.16,3.16,0,0,1,.17-5.46,5.14,5.14,0,0,1,5.57.7,4.06,4.06,0,0,1,0,5.62A6.08,6.08,0,0,0,334,121.14Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,126.52a3.16,3.16,0,0,1,.17-5.46,5.12,5.12,0,0,1,5.57.69,4.06,4.06,0,0,1,0,5.62A6.05,6.05,0,0,0,334,126.52Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Aorta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.64,123.8c-1.61-1.38-6.43-1.72-8.62,1.4-1.78-.79-4.73-4.1-5.47-5.19-.48-.71,0-5.44.09-7.17.14-2.62-2.49-3-2.63.18s-.47,4-1.06,4.65c-.88,1-4.49,2.33-5.51,2.79-1.54.71-.44,3.2,1.57,2.26s3.43-1.52,5.43-.56c1.36.66,2.32,2.32,2.42,4.94s-.36,3,.07,5.06,1.79,2.91,3.37,2.41c1.24-.39,1.08-1,1.68-2.31a4.92,4.92,0,0,1,4.08-3,6.61,6.61,0,0,1,6,2.66c1.59,2.25,2.15,4.17,3.79,4.17,1.08,0,1.13-1.83,1.08-3.7s-.33-4.17.8-5.39a46.43,46.43,0,0,1,4.91-4.26c.89-.61.17-2.54-1.47-1.13s-3.49,2.91-4.57,3-3.09-.47-2.29-2.48,5.36-7.9,6.44-9.35-.68-3.11-2.23-1.28a57.61,57.61,0,0,0-4.34,5.18C343.62,119,341.73,122.85,341.64,123.8Z",
    fill: "#ff5440",
    stroke: "#c93d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,146.42c-1,1.26-4.47,4.82-4.54,5.07,1.73,2.71,3.48,8.41,1.2,16.45-2.35,8.3-3.07,17.92-3.2,27.24s.57,26.11.7,29c.14,3.21-.12,5.75-3.93,7.16-2.14.8-1.23,3.34.4,3a8.73,8.73,0,0,0,4-1.83,497.43,497.43,0,0,0,4.68,76.36c.34,2.46,5.73,2.57,5.26-.14-3.83-21.83-5-51.14-4.7-76.16a9.19,9.19,0,0,0,3.86,2.07,1.68,1.68,0,1,0,1-3.23,7,7,0,0,1-4.83-6.83c-.17-4.53-.08-24.5,0-29.58s1.53-20.76,2.85-26.45S345.83,153.18,340.16,146.42Z",
    fill: "#ff5440",
    stroke: "#c93d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29,232.36c-1-.52-2,1.39-1,1.83S346.27,232.85,345.29,232.36Z",
    fill: "#ff5440",
    stroke: "#c93d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,232.08a1,1,0,0,0,.39,1.91C331.67,233.71,331.13,231.73,330.12,232.08Z",
    fill: "#ff5440",
    stroke: "#c93d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vena_Cava",
    "data-name": "Vena Cava"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.15,156.4c1-3.23-5.4-3-6.13.07-2.42,10.17-1.55,22.08.58,31.57.67,3,6.24,1.72,5.49-1.17C335.05,179,334.23,165.43,337.15,156.4Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.49,
    cy: 187.89,
    rx: 2.08,
    ry: 1.23,
    transform: "translate(-33.09 78.01) rotate(-12.68)",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_Interior_Outline",
    "data-name": "Body Interior Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.59,146.57c0-2.36.65-3.66-1.39-6.19s-12-15.14-13.6-18.16S366,104.31,363.86,99.67s-5.14-10.1-6.11-12.38-2-4.16-5-5.46-8.63-3.34-10.91-4.07-3.91-1.47-6.6-.49-10.1,3.42-12,4.4-3.58,1.79-4.8,4.48-7.25,14.41-10.59,21.33-5.62,12.54-6.6,14.34a64.21,64.21,0,0,1-5,7.16c-2.37,3.1-7.66,10.26-8.64,11.4a7,7,0,0,0-1.79,5.05c0,2.61-.49,15.39-.65,17.67a18.6,18.6,0,0,1-1.22,6.11c-.9,2.36-1.39,3.34-2,5a11.93,11.93,0,0,0-1,5.21c0,2.44-.41,18.81-.49,27.44s-.57,28.5-1,34.2-1.55,18.73-2.44,25.09-3.34,26.54-4.32,34.12-3,17.5-3.58,20.27-3.34,21.34-3.67,28-.32,10.75,1.22,13.19,7.33,10.34,13,14.17,19.14,11.4,35.92,13a207.54,207.54,0,0,0,46.9-.74c14.74-1.87,30.38-9.52,35.43-14a67.11,67.11,0,0,0,10.66-11.89c1.14-2,2-3.75,1.8-7.9s-3.34-30.78-4.4-36.56-2.69-15.15-3.42-21-2.93-24.19-4-31.68-2.45-21.42-2.45-27.36-.81-29.16-.89-34.86-.73-20.6-.82-23.21-.08-5.13-1.3-7.49-3.42-7.9-3.42-12.29S389.59,146.57,389.59,146.57Z",
    fill: "none",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spleen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.12,233.5v0c10.33,10.11,4,31.3-8.47,29.74l-.17.1C370.61,270.68,385.11,247.47,368.12,233.5Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,234.63c2.64,12.74-1.31,22.43-9.49,28.64C371.74,264.78,378,245.08,369.15,234.63Z",
    fill: "#ff7546",
    stroke: "#e5673e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Adrenal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.66,299.29c-1.33-9.22-8.43-9.45-11.89-7.13-3.95,2.66-4,5.47-4.56,9.83-.23,1.74,2.77,4.6,7,4.18C375.91,305.69,381.08,302.25,380.66,299.29Z",
    fill: "#a7da7e",
    stroke: "#64b145",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Kidney_Right_",
    "data-name": "Kidney (Right)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M364.42,312.69c1.42.32,7.89.4,9.86-1-.21.56-1.45,2.76-.92,4.32-2.81.82-7.21.54-9-.51C363.61,315,363.92,312.59,364.42,312.69Z",
    fill: "#ff5440",
    stroke: "#c93d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.16,333.3c.29-4.89,1.42-11.88,3.1-13.69a40.41,40.41,0,0,1,5.8-1.22,27.19,27.19,0,0,0-6.42,15.21C368.56,334.7,366.09,334.33,366.16,333.3Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.29,333.68c-.07.47-1.78.16-1.82-.27S368.35,333.27,368.29,333.68Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.48,317.65c1.46,0,6.43-1,8-2.85-.48,1.56,0,2.82,1,4.21-2.83,1.27-6.26,1.87-8.35,1.35C365.23,320,364.94,317.82,365.48,317.65Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.59,318c.42-.08.86,1.76.47,1.84S365.2,318.1,365.59,318Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.56,312.48c-5.45,1.78-7.77-3.58-6.86-7.77s3.37-7.56,9.73-7.56c6.07,0,8.22,4.68,9.19,6.29,3.22,3,4.85,7.45,4.15,12.92.62,6.55-1.33,11.58-4,14.65-4.62,5.28-10.66,4.39-14.56-1.15-2.75-3.91-1.5-8.86,2.71-10.56A6.25,6.25,0,0,1,373.56,312.48Z",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.46,313.14c.47.05.39,2,0,2S364.15,313.11,364.46,313.14Z",
    fill: "#c1272d",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,306.48c.12,3.28-1.71,4.86-4.21,6,2.32-1.4,4.18-2.13,7.31-.36",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.36,318.57c-1.79,2.94-6.47,2-7.45.73,2,1.37,3.67,2.63,4,6",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kidney_Left_",
    "data-name": "Kidney (Left)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.77,312.69c-1.42.32-7.89.4-9.86-1,.21.56,1.45,2.76.92,4.32,2.81.82,7.21.54,9-.51C311.58,315,311.27,312.59,310.77,312.69Z",
    fill: "#ff5440",
    stroke: "#c93d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,333.3c-.3-4.89-1.42-11.88-3.1-13.69a40.73,40.73,0,0,0-5.81-1.22,27.18,27.18,0,0,1,6.43,15.21C306.63,334.7,309.1,334.33,309,333.3Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9,333.68c.07.47,1.78.16,1.82-.27S306.84,333.27,306.9,333.68Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.71,317.65c-1.45,0-6.42-1-8-2.85.48,1.56-.06,2.82-1,4.21,2.84,1.27,6.26,1.87,8.36,1.35C310,320,310.25,317.82,309.71,317.65Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,318c-.43-.08-.87,1.76-.47,1.84S310,318.1,309.61,318Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.63,312.48c5.46,1.78,7.78-3.58,6.86-7.77s-3.37-7.56-9.72-7.56c-6.08,0-8.22,4.68-9.2,6.29-3.21,3-4.85,7.45-4.15,12.92-.62,6.55,1.33,11.58,4,14.65,4.61,5.28,10.65,4.39,14.55-1.15,2.75-3.91,1.5-8.86-2.71-10.56A6.23,6.23,0,0,0,301.63,312.48Z",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.73,313.14c-.47.05-.39,2,0,2S311,313.11,310.73,313.14Z",
    fill: "#c1272d",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.42,306.48c-.12,3.28,1.71,4.86,4.21,6-2.31-1.4-4.18-2.13-7.31-.36",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.83,318.57c1.8,2.94,6.48,2,7.45.73-2,1.37-3.67,2.63-4,6",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ovary"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379.94,347.45c-1,.87-2.64-1.22-1.56-2,.6-.42,3.76-2.28,4.05-4.64a12.43,12.43,0,0,0,2.67,3.79C383,344.84,381.3,346.26,379.94,347.45Z",
    fill: "#ebd7d6",
    stroke: "#edc3bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,344.85a2.3,2.3,0,0,0-1.39-.31c-.41,0-.88-.84-1.2-1.48a4.51,4.51,0,0,1-.23-3c.33-1.2-.16-1.51.9-2.92a4.67,4.67,0,0,1,2.6-1.83c1-.31,2.46.16,3.25.09a5.27,5.27,0,0,1,3.39.1,10.82,10.82,0,0,1,4.08,2.57,5.09,5.09,0,0,1,.41,4.52,4.29,4.29,0,0,1-3.69,2.6c-1.62.14-1.92.55-3.78.14C388.3,345,387.44,346.11,385.23,344.85Z",
    fill: "#f060a6",
    stroke: "#b44878",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,345.87c-.51.38.53,1.7,1,1.41S379,345.49,378.51,345.87Z",
    fill: "#ebd7d6",
    stroke: "#edc3bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,345.07c-2.48-1.8-9.39-2.78-16.62,4.14a90.26,90.26,0,0,1-18.54,13.41c1.07,5.12,4.13,12.58,4.11,17.13,4-6.15,12-10.39,16.71-17.05,4.59-6.42,6.45-10.66,8.07-12.84s3.59-3.46,5-2.5C379.7,348.44,381.57,346.7,379.32,345.07Z",
    fill: "#ebd7d6",
    stroke: "#edc3bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gradient_for_Ovary",
    "data-name": "Gradient for Ovary"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.93,
    y: 351.48,
    width: 30.89,
    height: 19.06,
    transform: "translate(-149.54 328.17) rotate(-41.58)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Small_Intestine",
    "data-name": "Small Intestine"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.62,261.76c-.45,1.71-4.26,4.13-8.49,2.22a7.4,7.4,0,0,0,2.87.69,4.77,4.77,0,0,1-7.75,1.39,4.66,4.66,0,0,0,2.18,1.32c-1.43,2.4-4.9,4.35-8.46.91a6.45,6.45,0,0,0,2.81,1.7c-1.1,2.48-4.15,3.5-7,1.24a6.36,6.36,0,0,0,2,1.08c-1.1,2.36-4.9,3-6.39,3.05-2.28.12-5.29-2-5.33-3.22s2.48-5.25,6.55-6.31,12.7-3.66,15.68-4.93,6.31-3.62,7.45-2.64S336.62,261.76,336.62,261.76Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.77,284.72A22.81,22.81,0,0,0,293,279a6.88,6.88,0,0,0-7.58,0c-3,2.08-3.17,4.93-1.91,8a21.71,21.71,0,0,0,4.28,6.23c1.38-.4,4.07-3.34,4.39-3.82-.85-.78-3.87-3.18-3.17-5.34,1.5-2.19,4.5,0,7.29,3.3Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,281.88c1.29,2-.48,3.42-2,2.72",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.42,361.2c-.27-2.55-3.3-10.15,5.07-11.43-1.59-2.75-.31-6.48-7.27-5.8s-6.35,3-6.72,6.78S301.63,363.26,301.42,361.2Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,350.62A9.92,9.92,0,0,1,301,353a4.93,4.93,0,0,1-1.89-.39",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309,327.23c1,1.35,3.57,6.66-6.17,9.59,4.7,1,15.82.12,18.81-1s-5-13.88-6.17-14.82C311.43,324.61,309,327.23,309,327.23Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M314,324.83c-.55,3.44-3.32,11,8.73,9.28,11.16-2.85,9.28-3.11,11.24-4.49a67.27,67.27,0,0,1-10.63-.56c-1.71-.24-1.42-2.11,0-2.44s4.81-1.46,6.35-1.79c1.79-.08,9-11.48,9-11.48l-.73-5.78L327,308Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,326.29c2.08.33,2.72,3.17-.27,3.6",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M334.62,324.26c-5,4.23-11.16,8.79-16.45,10.18s-10.5,1-16,0-8.36-1-10-.87-4.55,1.78-6.24,4.59A30.8,30.8,0,0,0,282.34,354c.33,6.76,3.44,15.45,12.79,16.13-8.1-1-11.81-6.17-12.77-15.79-.46,7.63-.3,13.28,1.89,16.15s5.32,5.56,11.85,5.5,9.84-3.24,9.9-7.94-2.75-7.15-4.77-9.89-5.43-6.42-4.58-10.2c1.47-.55,3.79.24,5,1.46s2.32,2.55,4.89,2.45c4.67-.19,10.59-8.31,14.61-12.45-.7.07-1.58.09-2.09.17,9-.45,17.34-4.56,20.6-7.94a84,84,0,0,0,6.37-7.82l-3.68-7.08Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.69,342.87a6.52,6.52,0,0,0-2.16,4.89c-.33-1.84-.53-3.22-2.28-3.87",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.76,346.12a21.69,21.69,0,0,1,1.89,1.82",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293,372a4.45,4.45,0,0,0,0-2.27",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M353.94,329.25c-.12-1.84-.67-3.38-2.62-3.63a19.64,19.64,0,0,0-6.41-.15c-2.94.42-8.07,2.68-8.74,6.53a36.4,36.4,0,0,0,0,13.13c.91,4.46.67,6,.24,11.36s-.67,9.71.55,12.58c1.34,3.16,3.24,7.33,3,9.22a54.93,54.93,0,0,1-2.87,8.86c-1.51,3.66,0,6.05.88,7.69,1.44,2.57,8-1.16,6-5.86-.33-2.06.92-4.4,1.47-6.66a17.64,17.64,0,0,0-1.1-11.24,24.12,24.12,0,0,1-1.93-13c1.37-8.11.34-14.86.34-17.05s.61-8.54,1.71-9.39S353.94,329.25,353.94,329.25Z",
    fill: "#efaa86",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,292.17c4.09.07,22.42.19,24.13,0s7.77-3.51,7.51-5.34c-.67-4.61-3.91-7.05-9.59-7.73-.64-.07-7.38,11-8,10.94-3.69-.49-4.64.61-4.37-12.81-2.5-.43-4.18-.75-4.18-.75l-7.78,2.32-1.31,7.14Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.86,283.87a23.28,23.28,0,0,0-8.49,5.8c-1.9,2.38,3.6,2.1,6.47,1.69s5.25-1,6.05-1.08,1.22.55,1.22,2,.06,7.2,0,8.3-1.53,3.13-3.73,5.57-5.13,5.12-5.92,6.4-2.18,3.32-2.18,5.42c0,1.38.55,5,.48,6.13s-.56,1.83-4.41,2.26-7.33,1.52-8.67,3.29-2.28,7.36.37,9.72a5.84,5.84,0,0,0,8.33-.25c1.95-2.14,2.07-5.06,2.07-6.7a64.74,64.74,0,0,1-7.47,0,49.19,49.19,0,0,0,10.44-.42c2.38-.55,7.21-1,7.64-8.19S364.81,312,368.14,308s5.41-7.66,5.41-12.1a16.92,16.92,0,0,0-3.06-9.4C369.21,284.36,367.74,282.34,362.86,283.87Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M365.52,287.41c-.4,4.64,3,3,1.92,0",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.84,289.67c-1.4.43-1.4,2.23.83,1.31",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.36,327.05c-.93-1.95.59-3.33,1.89-2.38",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,337.43c.57-1.7,2.64-2.18,3.33.1",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,336.43a12.39,12.39,0,0,1,6.27-.12",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.94,333c.53.19,1.35.32,1.69-.22",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.83,278.43c0,1.41.54,8.89.54,10.3a48.92,48.92,0,0,1,4.69-9.44c.76-1.22,2-.31,1.19,1s-3.55,7-4.3,8.52a30.32,30.32,0,0,1,.11,3.82c2,1.94,6.2,4,8.64,5s1.65,4.8,0,6.15-4.58,4-5,7.27-.61,8.85-3.12,9-3.24-1.58-3.11-6.16c-1.29,1.22-5.56,5.8-5.56,5.8.06,1.71-.43,4.64,1.65,6.17a18.22,18.22,0,0,1,8.61,0c3.36.79,6.11-.31,6.05-3.3s-.13-5.62,0-6.6,1.83-3.66,4-5.5,5.37-5.48,5.25-8.75-2.14-9.57-3.54-11.46-5.55-2.32-7.21-2.2-3.18.18-3.18.18a5.8,5.8,0,0,0,3.33-.79,10.69,10.69,0,0,0,4.06-6.41c.31-2.39-.06-4.65-2.87-6.05s-5.49-1.71-7.27,0A21.73,21.73,0,0,0,347.83,278.43Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.67,277.33c-1.22,1.35-.18,2.81,2.29,1.13",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.41,319.74c-2.36-.74-4.59,0-4.72,3.26",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.2,322a2.63,2.63,0,0,1,2.38-2",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.05,311.07c0,1.42,0,2.45,0,3",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.17,304.11c-.49.4-5.87,5.29-7.33,6.57,2.14-.79,6-.79,6.55.55s.35,2.75-1.73,3.54a13.22,13.22,0,0,0-7.33,6.42c-1.71,3.72.12,5.2,1.32,5.83,1.39.74,4.36,1.25,9.86-1.86s11.06-9.65,12.52-11.3a69.93,69.93,0,0,0,5.3-6.76c-1.45-2.28-8.33-4.79-9.29-5.21-.16,3.29,0,6.59-3,9.34-1.65,5.8-7.15,11.13-12.16,12.19,5.56-1.2,10.77-6.73,12.16-12.19C344.54,305.19,337,304.14,336.17,304.11Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337,310c-2.62,1.17-1.49,3.1,1,2.34",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,314.89a.94.94,0,0,0-1.14-1.17",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.07,282.57c-4.32.16-7.53.08-8.57.75a5.44,5.44,0,0,0-1.83,4.33c0,1.84,1,17.9.79,21.26s-.24,10.26.37,12.89a5.14,5.14,0,0,0,5,4.09c2.13-.06,8-2.81,6.27-10.08,1.12,2.38,2,4.95.75,7s-2.32,5.07.3,7.21c2.09,1.7,4.58,3.12,9.29-1.77s10.07-12.34,14.2-15.09,12.43-7.78,12.18-13.48S316,311,313.63,312.7s-7.57,2.13-8.43-1,1.71-7.57,2.38-9.47-4-3.54-4-3.54-2.81-2-3.17.37a26.91,26.91,0,0,0-.61,5.47c0,6.38.53,15-5,14.82,2.91,0,3.78-2.17,4.21-3.41-1.45,1.81-1.62-7.68-.57-14.23.58-3.61,1.81-4.48,2.26-6.26A27.42,27.42,0,0,0,301.07,282.57Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.41,277c-5.44-.6-10.75-1-13.37-1S303.49,277.3,300,281c-4.09,4.27-5.47,7.34-5.74,9.46-.92,7.11,7.45,14.85,13.56,16.62s8.24.5,11.17-.91c-6,3-9,5.3-9.89,6.4a5.64,5.64,0,0,0-.61,5.32c.85,1.89,1.77,4.33,2.87,4.88s3.6,1.57,6.9-1.16c6.35-5.25,9.47-10.75,13.25-17.83s4.34-19.24,4.28-20.89S329.75,277.11,328.41,277Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.46,317.43c2.1-.7,3.38.79,2.88,2.59",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.05,298.07c-.18.67-.14,1.77.43,2.17",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.55,300.11A26.44,26.44,0,0,1,318,304.94a4.42,4.42,0,0,1,1.62,5.8,26.22,26.22,0,0,1-5.62,7c-.86.62-2.2-.39-1.22-1.61s4.06-3.3,5.77-3.51",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M317,278.49c0,1.88.61,2.86,3.05,3",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.58,293.71c-.24-2-.79-5-.79-5-3.14,2-7,7.91-7.56,8.82C302.58,296.25,307.26,294.41,308.58,293.71Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,281.88c-2.92,0-4.81,1.38-6,1.38s-7.8-.8-10.89,2.07a56.11,56.11,0,0,0-5.91,6.54c-.85,1-2.69,1.46-4.46,0s-4.64-3.6-8-1.77-5.8,5.48-6,7.47-.49,5.54,4.15,6.33,10.2-.67,14.66-4.09,9.77-8.92,11.23-9.77,9.9-.48,9.9-.48Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M288,293.71c-.73,4,2.32,5.47,6.64,5.1",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.54,298.2a3.61,3.61,0,0,0,4.78-.33,3.32,3.32,0,0,1-1.31-1.82A3.51,3.51,0,0,1,284.54,298.2Z",
    fill: "#fff",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.63,290.42c.36,7.15-1.53,8.53-3.7,11a4.65,4.65,0,0,1-6.36.15,68.37,68.37,0,0,1-7.45-6.6c-1.1-1.38-1.27-7.69-1-9a7,7,0,0,1,2.4-3.87c1.1-.78,8-.74,10.26-.86s8.65,1.51,11.12,6.92,5,9.41,2.2,13.32-3.91,4.84-5.58,4.64-1.94-1.22-2-4.44c0-.62,0-4.38.18-7a2.43,2.43,0,0,1,1.77-2.05,2.47,2.47,0,0,0-1.77,2.05C332.64,292.72,332.63,290.42,332.63,290.42Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M326,298.16c-.51-2.44.49-3.08,2.44-1.65",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63,291.56c.95,0,2.49-.05,3,1.28",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327,294.41c0,1.37-.66,2-2,1s-4.48-5.09-4.48-5.66,1.79-3.87,3.06-2.69S327,291.4,327,294.41Z",
    fill: "#fff",
    stroke: "#c07a53",
    strokeMiterlimit: 10,
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M336.05,275.93c-1.71,1.77.28,7.05,1.91,6.35a11.54,11.54,0,0,0,4.32-3.54c.48,2.56.42,7.69.48,11.6s-.12,12,.43,13.13,3.67,6.84,10.2,6.17a18,18,0,0,0,2.69-3.85,87.74,87.74,0,0,0,.61-9.1c-2-.85-6.14-3.38-6.63-4.09a23.11,23.11,0,0,1-1.25,7.08A26.43,26.43,0,0,0,350,289.06c-.37-4.58-.18-11.91-2.32-14.23a6.71,6.71,0,0,0-7.33-1.83A10.88,10.88,0,0,0,336.05,275.93Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.29,277.09a6.4,6.4,0,0,1,1,1.65c.45-.58.73-.93,1.09-1.47",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.27,299.68c3.33,0,4.64,1.53,4.43,3.9",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,297.85a2.75,2.75,0,0,1,3,2.26",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.28,301.32a1.42,1.42,0,0,1,1.83,1.39",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.39,217.42c-3.07.51-6.73,1.19-10.62,2a11.47,11.47,0,0,1-1.6,7.25c-2.19,4-4.84,12.87.83,14.63,2.41.75,5-.66,6.91-2-.88.74-4.12,2.7-6.49,2.11a3.56,3.56,0,0,1,1.2,2.68c2,1.53,4.15,3.26,4.94,4.48a25.31,25.31,0,0,0-4.94-4.48,8.11,8.11,0,0,1-5.58-2.3c-.92-1-3.9-3.18-9.16-2.94a13.71,13.71,0,0,0-11.28,9c-1,2.86-.2,7.27,2.32,8.64-1.06-.49-2.51-2.3-2.72-5.26-2.27,0-4.77,2.22-4,7.72a13.38,13.38,0,0,1,0-3.68,7.56,7.56,0,0,0-5.14.52c.28-9.36,3.47-21.82,9.85-31.29-1.19.25-2.3.48-3.33.68-7.33,9.83-9.23,23.31-10.73,32.75-7.76,2.57-12.65,5.93-15,9.1s-1.1,7,2,9.77,6.59,4.1,6.59,6.23c0,3.73-.09,8.68-.12,10.39-.06,3.42,4.4,6.29,11.18,2.07,5.24-3.26,11.13-11.15,14.47-14.78a4.3,4.3,0,0,0,3.67-.53,4.19,4.19,0,0,1-3.67.53c-1.24,1.41-3.1,3.58-4.51,5.24,4.36,4.35,9.2,2.51,10.86-.53,2.93-5.38,1.47-10.94-3.35-12.4s-7.15.79-11.36,6-7.64,9.16-8.49,9.77c-1-.3-2.26-.85-2.26-.85-.19-5.8,1-11.36-4.22-13.68s-2.14-4.64-1-5.32,3.48-1.46,7.52-1.52a11.14,11.14,0,0,0,9.1-4.46c5.66.43,8.75-3.46,11.05-10.24-1.11,3-1.69,4.82-3.73,7.23,5.48,7.71,17,10.15,24.9,5.55C370.53,257.29,375.37,240.74,362.39,217.42Z",
    fill: "#fbccad",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,290.49c0-1.09.16-1.7-.76-2.08a2.43,2.43,0,0,0-2.93,1.44",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.66,285.29c-.1-1.79-.24-3,1.14-4.44",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.69,285.78a7.35,7.35,0,0,1,.71-4.52",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.24,348c-2,.2-2,2.37.45,2.24",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.35,364.67c2.66-.21,3,1.92.46,2.05",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,379.57a3.13,3.13,0,0,1-2.37-1.28",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,376.3c-.59.18-1.7,0-1.91-.66",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.58,388.8c-2.32-1.76-7.76,4.17-5.27,6.46C340.69,397.18,346.39,392.3,343.58,388.8Z",
    fill: "#efaa86",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,390.94c-1.06-.8-3.52,1.89-2.39,2.93C341.38,394.74,344,392.52,342.69,390.94Z",
    fill: "#c07a53"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.46,333.77a2.13,2.13,0,0,0,2.12,2.22c1.62,0,2.33-1.43,2.12-3.43-1.34,0-3.5-.07-3.72-.08C346.45,332.47,346.46,333.77,346.46,333.77Z",
    fill: "#fff",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.09,317.09a2,2,0,0,0,3.18.34",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.05,258.46c0-.12,0-2.17,0-3.3",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,252c-1.91-1.83-2.47-5.25-1.36-8",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.89,242.34c-1.47-.58-4.8,0-6.29,1.29",
    fill: "none",
    stroke: "#c07a53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Testis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.4,364.75c-6.15,0-9.07,7.79-9,14.18,0,6.61,3.57,14.36,9.43,14.18,5.64-.18,8.75-7.86,8.75-14.61C361.54,372.56,359.16,364.75,352.4,364.75Z",
    fill: "#94bfcf",
    stroke: "#3d5d6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gastroc_Core",
    "data-name": "Gastroc Core"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,395.29a10.92,10.92,0,0,1-3.08,3.76c-3.12,2.66-5.58,4.07-5.46,7.82.12,3.3,1.67,6.15,1.11,9.69-.32,2-.87,3.37-1.26,5.19-.17.53,1.92,1.12,2.12.49a24.77,24.77,0,0,1,2.17-4.81c2.88-5.87,4.16-10.06,4.63-14.52a26.14,26.14,0,0,1,1.62-7.17C377,395.22,375.11,394.78,375,395.29Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.81,423.09a3,3,0,0,1-.89-.15c-1.05-.33-1.29-.92-1.15-1.36.15-.71.34-1.4.53-2.08a26.49,26.49,0,0,0,.71-3,14.43,14.43,0,0,0-.49-5.61,21.94,21.94,0,0,1-.62-4c-.12-3.52,1.88-5.17,4.42-7.25.39-.32.81-.66,1.23-1a10.56,10.56,0,0,0,2.91-3.47.78.78,0,0,1,.57-.58,2.52,2.52,0,0,1,2.09.47.85.85,0,0,1,.3.83l-.13.39a25.22,25.22,0,0,0-1.47,6.72c-.5,4.68-1.86,8.94-4.69,14.72-.23.47-.47.94-.71,1.39a14.07,14.07,0,0,0-1.41,3.28A1.14,1.14,0,0,1,367.81,423.09Zm-.89-1.39a2.27,2.27,0,0,0,1,.24,15.53,15.53,0,0,1,1.47-3.4c.23-.44.47-.89.7-1.36,2.76-5.64,4.09-9.79,4.57-14.33a26.31,26.31,0,0,1,1.54-7l0-.06a1.6,1.6,0,0,0-.73-.17,12.1,12.1,0,0,1-3.2,3.85c-.43.37-.85.71-1.25,1-2.47,2-4.1,3.36-4,6.32a20.28,20.28,0,0,0,.59,3.76,15.54,15.54,0,0,1,.51,6,26.9,26.9,0,0,1-.74,3.16C367.24,420.42,367.07,421,366.92,421.7Zm0,.13v0A.06.06,0,0,0,366.89,421.83ZM375,395.29h0Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gastroc_Muscle",
    "data-name": "Gastroc Muscle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.76,417.89a3.16,3.16,0,0,1-2.13-.83.64.64,0,0,1-.17-.52,14.9,14.9,0,0,0-.5-5.78,22.24,22.24,0,0,1-.61-3.89c-.11-3.3,1.72-4.8,4.26-6.88l1.24-1a1.37,1.37,0,0,1,.91-.25,4.16,4.16,0,0,1,2.77,1,.69.69,0,0,1,.19.6c-.14.78-.25,1.62-.36,2.58-.49,4.63-1.84,8.85-4.64,14.57a1.06,1.06,0,0,1-1,.4Z",
    fill: "#ff8ea2",
    stroke: "#d6515c",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,399.05c-3.12,2.66-5.58,4.07-5.46,7.82.12,3.3,1.67,6.15,1.11,9.69-.16.85,2.53,1.69,3,.87,2.88-5.87,4.16-10.06,4.63-14.52.11-1,.23-1.85.36-2.59C375.8,399.29,372.64,398.41,371.93,399.05Z",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vastus_Core",
    "data-name": "Vastus Core"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.46,371.94c.34-1-2.51-2.48-3.61-1.67-5.45,3.34-16.75,9.55-22.27,28.46-.73,1.63,1.22,2.81,1.87,2.34C396.27,392.64,405.36,385.11,410.46,371.94Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,401.74a2.18,2.18,0,0,1-1.33-.52,2.25,2.25,0,0,1-.68-2.73c5.34-18.29,16.06-24.8,21.82-28.3l.68-.41c1-.72,2.67-.13,3.57.52s1.09,1.22.88,1.82v0c-5,12.92-13.9,20.55-23.31,28.62l-.85.73A1.3,1.3,0,0,1,386.06,401.74Zm21.64-31.13a.86.86,0,0,0-.5.12l-.73.45c-5.63,3.41-16.1,9.77-21.34,27.71a1.19,1.19,0,0,0,1,1.7l.8-.69c9.3-8,18.08-15.5,23-28.14,0-.11-.27-.47-.9-.8A3.1,3.1,0,0,0,407.7,370.61Zm2.76,1.33h0Z",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vastus_Muscle",
    "data-name": "Vastus Muscle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.12,373.27a42.64,42.64,0,0,0-15.64,20c-.69,1.71,3.3,5,4.92,3.58,6.54-5.74,12.47-11.59,16.72-19.7C409,375.48,403.93,372,402.12,373.27Z",
    fill: "#ff9350",
    stroke: "#c06437",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Liver"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.31,216c-12.3-11.48-45.73,4.12-57,9.94-4.47,2.31-7.48,3.78-9.71,4.7,6.41-1,8.62-3.35,15.08-4.38,6.68-1,42.51-9.2,51.47-9.77a6.26,6.26,0,0,0,1.56-.4Z",
    fill: "#ff8d90",
    stroke: "#ff675d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.88,204.46A64,64,0,0,0,295,219.21c0-.12.1-.25.14-.37a8.65,8.65,0,0,1,1.6,6.19c5.87-5.78,19-14.68,25.87-18.93a66.71,66.71,0,0,1,28.9-10.16c1.43-.1,1.18,0-.05-.38C335.92,191.16,319.33,193.73,302.88,204.46Z",
    fill: "#ffb1b8",
    stroke: "#ff675d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88,227.11c-2,2.55-1.55,4.65,1.47,4.89s5.53-.65,16-6c11.27-5.82,44.7-21.42,57-9.94,3.5.49,4.32-1.14,3.26-3.09s-8.86-10.57-20.07-17.1a66.55,66.55,0,0,0-29.85,10.26C314.91,210.9,299.12,221.65,294.88,227.11Z",
    fill: "#ffb1b8",
    stroke: "#ff675d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,219.21c-3.68,3.92-8.78,7.57-11.28,8.19,4.29,2.81,8.42,2.87,10.88,1.26s3.34-5.7.54-9.82C295.14,219,295.09,219.09,295,219.21Z",
    fill: "#ff8d90",
    stroke: "#ff675d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.31,221.3a13,13,0,0,0-1.05,5.4c0,2.77,7.73-2.12,12.78-7.49a64,64,0,0,1,7.84-14.75A105.09,105.09,0,0,0,283.31,221.3Z",
    fill: "#ffb1b8",
    stroke: "#ff675d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Diaphragm"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.17,222.19c0,1.46-.07,2.68-.07,2.68,40.53-46.89,85.38-38.29,116,6.48,0-1.14,0-2.94-.1-4C363.69,178.9,311.74,182.24,280.17,222.19Z",
    fill: "#c7bdba",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lung_-_Left_Lobe",
    "data-name": "Lung - Left Lobe"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.12,198.36c-4.63-2.91-10.89-10.79-13.33-14.71a75,75,0,0,1-6-13.7c-1.15-4.16-3.25-11.94-4.21-16.1-.13-.58-.27-1.13-.41-1.68-.45,13.79-.6,21.24,0,25.85,1.43,10.5,14.09,22.49,25.41,21l0,0A3.53,3.53,0,0,1,378.12,198.36Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.12,198.36c-4.63-2.91-10.89-10.79-13.33-14.71-.24-.38-.54-.93-.89-1.59h0c1.16,5,5,19.75,15.71,16.95l0,0A3.53,3.53,0,0,1,378.12,198.36Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45,131.55c-2-1.07-5.88-2.82-8.07-1.77s-2.63,3.63-3,5-.15,3.63,1.48,7.65a70.69,70.69,0,0,1,3.72,11.41c1,4.16,3.06,11.94,4.21,16.1a75,75,0,0,0,6,13.7c2.44,3.92,8.7,11.8,13.33,14.71,2.36,1.49,2.67.29,2.77-2.77s-.91-17.05-1.72-22.49-2.53-15.95-3.25-19.73a30.8,30.8,0,0,0-5.35-12.13C367.8,137.56,362.57,132.7,360.45,131.55Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lung_-_Right_Lobe",
    "data-name": "Lung - Right Lobe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.48,193.71c-6.11,1.38-11.67,2.17-14.89,3.51a4.68,4.68,0,0,1-1,.3c11.27,5.2,27.07-2.52,29-11l-.29.15C315.24,189.69,310.07,192.45,304.48,193.71Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.4,143.18v-.26c-1.23.84-3,2-4.17,2.72a5.19,5.19,0,0,1,.8,3.43c1.45-.89,3.07-1.93,4.07-2.58A8.28,8.28,0,0,1,325.4,143.18Z",
    fill: "#fece62",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27,142.41a65.4,65.4,0,0,0,1.66-9c.36-4.29-1.4-4.34-3.51-3.82s-9.9,4.31-15.45,11.75S294.1,163.25,293.52,167s-.28,5.13.42,5.55a1,1,0,0,0,1,0c-.22,2.94-2.32,5.81-4.28,9.52s-3.78,6.46-5,11.87c-.71,3.16,1.4,4.42,3.93,3.37,3.22-1.34,8.78-2.13,14.89-3.51s11.73-4.55,13.34-7.87c2.32-4.77,1.9-11.1,2.18-15.59,2.87-3.56,4.08-6,3.86-9s-2-4.78-2.45-6.46.21-2.81.49-4.5.26-3.68-.81-4.85h0C322.18,144.68,322.08,143.57,322.27,142.41Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27,142.41a65.4,65.4,0,0,0,1.66-9c.36-4.29-1.4-4.34-3.51-3.82s-9.9,4.31-15.45,11.75S294.1,163.25,293.52,167s-.28,5.13.42,5.55a1,1,0,0,0,1,0c1.55-3.12,5.05-8.43,9.42-11.5,3.52-2.48,7.4-2.85,10.25-3.66,2.5-.71,4.83-3.18,6.82-2.5-.5-1.69.21-2.81.49-4.5s.26-3.68-.81-4.85h0C322.18,144.68,322.08,143.57,322.27,142.41Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27,142.41a65.4,65.4,0,0,0,1.66-9c.36-4.29-1.4-4.34-3.51-3.82s-9.9,4.31-15.45,11.75a50.36,50.36,0,0,0-4.05,6.62c1.83-1.89,4.95-4.24,8.15-4.46,3.38-.24,4.55.68,6.88,1,2,.25,4-.89,5.14.93C322.19,144.67,322.08,143.57,322.27,142.41Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.71,131.87a17,17,0,0,0-6,7.73,24.94,24.94,0,0,0-1.51,9.13c0,4.71,4.14,8.53,7.36,10.56s9.32,3.93,14.1.66,5.1-7.78,4.45-14.19c-.61-6.11-2.67-9.6-5.31-13.33-2.89-4.08-6.64-5.33-9.17-4S333.13,130.79,331.71,131.87Z",
    fill: "#c1272d",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "White_Adipose",
    "data-name": "White Adipose"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 303.59,
    cy: 382.77,
    r: 12.43,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.32,
    cy: 381.04,
    rx: 4.07,
    ry: 2.73,
    stroke: "#ffb607",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.95,
    cy: 382.66,
    rx: 3.29,
    ry: 1.75,
    transform: "translate(-22.06 18.13) rotate(-3.38)",
    stroke: "#ffb607",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.33,
    cy: 382.54,
    rx: 5.09,
    ry: 3.25,
    transform: "translate(-12.87 10.78) rotate(-1.96)",
    stroke: "#ffb607",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.77,
    cy: 383.42,
    rx: 5.61,
    ry: 2.74,
    transform: "translate(-24.28 20.49) rotate(-3.73)",
    stroke: "#ffb607",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.12,
    cy: 380.35,
    rx: 3.85,
    ry: 2.71,
    transform: "translate(-22.34 19.18) rotate(-3.45)",
    stroke: "#ffb607",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.1,
    cy: 385.62,
    rx: 3.25,
    ry: 2.12,
    stroke: "#ffb607",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-6)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Brown_Adipose",
    "data-name": "Brown Adipose"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 303.23,
    cy: 118.92,
    r: 12.43,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.96,
    cy: 117.2,
    rx: 4.07,
    ry: 2.73,
    stroke: "#a6734f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.59,
    cy: 118.82,
    rx: 3.29,
    ry: 1.75,
    transform: "translate(-6.5 17.65) rotate(-3.38)",
    stroke: "#a6734f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.97,
    cy: 118.7,
    rx: 5.09,
    ry: 3.25,
    transform: "translate(-3.87 10.61) rotate(-1.96)",
    stroke: "#a6734f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.4,
    cy: 119.57,
    rx: 5.61,
    ry: 2.74,
    transform: "translate(-7.13 19.9) rotate(-3.73)",
    stroke: "#a6734f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-10)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.75,
    cy: 116.5,
    rx: 3.85,
    ry: 2.71,
    transform: "translate(-6.46 18.68) rotate(-3.45)",
    stroke: "#a6734f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.73,
    cy: 121.78,
    rx: 3.25,
    ry: 2.12,
    stroke: "#a6734f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15,
    fill: "url(#radial-gradient-12)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.43,
    cy: 115.29,
    rx: 0.36,
    ry: 0.24,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.5,
    cy: 116.6,
    rx: 0.52,
    ry: 0.36,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.87,
    cy: 117.15,
    rx: 0.45,
    ry: 0.31,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.81,
    cy: 118.61,
    rx: 0.58,
    ry: 0.41,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.03,
    cy: 119.17,
    rx: 0.27,
    ry: 0.19,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.47,
    cy: 120.38,
    rx: 0.65,
    ry: 0.42,
    transform: "translate(-10.16 29.72) rotate(-5.51)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.79,
    cy: 120.28,
    rx: 0.41,
    ry: 0.25,
    transform: "translate(-10.16 29.56) rotate(-5.51)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.58,
    cy: 118.39,
    rx: 0.29,
    ry: 0.18,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.89,
    cy: 121.98,
    rx: 0.32,
    ry: 0.24,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.26,
    cy: 121.25,
    rx: 0.21,
    ry: 0.18,
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Brain_Zoom_Circle_Base",
    "data-name": "Brain Zoom Circle Base"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.04,
    cy: 60.7,
    r: 27.1,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Brain"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.73,46.71c-2.68-.65-11-1.41-11.6.14A8.94,8.94,0,0,1,324,50.23c-1.07,1.11-2.68,2.31-2.76,5.22s1.17,5.27.33,8S322.7,71,324,72.57c1.44,1.8,10.51,4,13.78,2.7Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,46.71c-2.68-.65-9.2,5-10.86,4.71-.84-.16-2.73,2.33-3.07,5-.51,4,0,4.63-.63,7.12-1.4,5.38-.47,7.46.78,9,1.44,1.8,10.51,4,13.78,2.7Z",
    fill: "#f9b882",
    stroke: "#a06946",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.73,46.71c2.68-.65,11-1.41,11.61.14a8.94,8.94,0,0,0,2.12,3.38c1.07,1.11,2.68,2.31,2.76,5.22s-1.17,5.27-.33,8-1.12,7.53-2.37,9.1c-1.44,1.8-10.51,4-13.79,2.7Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,46.71c2.68-.65,9.21,5,10.86,4.71.85-.16,2.74,2.33,3.08,5,.51,4,0,4.63.62,7.12,1.41,5.38.48,7.46-.77,9-1.44,1.8-10.51,4-13.79,2.7Z",
    fill: "#f9b882",
    stroke: "#a06946",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,76.9c-.5,2.64,1.52,7.26,6.24,5.45C337.09,80.28,327,68.59,325.47,76.9Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.18,76.9c.49,2.64-1.52,7.26-6.24,5.45C338.55,80.28,348.61,68.59,350.18,76.9Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M326.48,74.26c-2.39-2.18-5.17-.72-5.07,2.42s3,5.18,5.4,1.65C328.1,76.39,327.91,75.56,326.48,74.26Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.48,74.26c-2.39-2.18-3.32-1-3.22,2.15s1.61,4.75,3.55,1.92C328.13,76.41,327.91,75.56,326.48,74.26Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.13,74.26c2.39-2.18,5.17-.72,5.07,2.42s-3,5.18-5.4,1.65C347.5,76.39,347.7,75.56,349.13,74.26Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.13,74.26c2.39-2.18,3.32-1,3.22,2.15s-1.61,4.75-3.55,1.92C347.48,76.41,347.7,75.56,349.13,74.26Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,45.88v-5.3c0-2.4-3.44-2.28-4.08-2.28-1.37,0-3.53,2.79-5,4.51a47.64,47.64,0,0,0-3.24,3.93c-1.71,2.59.95,4.14,1.64,4.93a30.63,30.63,0,0,1,3.06,3.85,7.63,7.63,0,0,0,3,2.56c1.61.56,4.6-.11,4.6-1.84Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,45.88V37.4c0-2.4-5.24-1.4-5.39.36a23.64,23.64,0,0,1-1.61,6.31,12.65,12.65,0,0,1-2.7,4.31c-1.1,1-1.66,2.5-1,3.29a30.63,30.63,0,0,1,3.06,3.85,7.63,7.63,0,0,0,3,2.56c1.61.56,4.6-.11,4.6-1.84Z",
    fill: "#f9b882",
    stroke: "#a06946",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,45.88v-5.3c0-2.4,3.44-2.28,4.08-2.28,1.37,0,3.53,2.79,5,4.51A45.7,45.7,0,0,1,350,46.74c1.71,2.59-.94,4.14-1.63,4.93a29.75,29.75,0,0,0-3.06,3.85,7.76,7.76,0,0,1-3,2.56c-1.61.56-4.6-.11-4.6-1.84Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,45.88V37.4c0-2.4,5.24-1.4,5.39.36a23.64,23.64,0,0,0,1.61,6.31,12.5,12.5,0,0,0,2.7,4.31c1.1,1,1.66,2.5,1,3.29a29.75,29.75,0,0,0-3.06,3.85,7.76,7.76,0,0,1-3,2.56c-1.61.56-4.6-.11-4.6-1.84Z",
    fill: "#f9b882",
    stroke: "#a06946",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,30.63c.76-2.45,3.93-.73,4.86,0,.72.56,2.19,2.1,2,5.4a10.47,10.47,0,0,1-4.7,8c-1.44.89-2.16.84-2.16-.69Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,30.63c-.76-2.45-3.94-.73-4.86,0-.72.56-2.2,2.1-2,5.4a10.47,10.47,0,0,0,4.7,8c1.44.89,2.16.84,2.16-.69Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,62.29c0-1.67-3.58-1-3.66.15a6.14,6.14,0,0,1-1.69,3.47c-2.77,3.33-3,9.92-2.94,11.94s-1.17,4.58.95,6.41c1.88,1.63,3.3,10.48,3.07,12.71-.18,1.79-.34,2.34,1.32,2.34,1.3,0,1.74-.74,1.75-1.2a1.94,1.94,0,0,1,1.2-1.57Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,62.29c0-1.67,3.59-1,3.66.15a6.21,6.21,0,0,0,1.69,3.47c2.77,3.33,3,9.92,2.95,11.94s1.17,4.58-1,6.41c-1.88,1.63-3.3,10.48-3.07,12.71.18,1.79.34,2.34-1.32,2.34-1.3,0-1.73-.74-1.75-1.2a1.94,1.94,0,0,0-1.2-1.57Z",
    fill: "#d36262",
    stroke: "#8c1515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.27,69.68a5.63,5.63,0,0,1,.4-2.79,2.9,2.9,0,0,0,1.06-2.46c-1.25.81-5.71.84-6-.18.15,1.71.3,2,1.05,2.63.58.52.49,1.94.49,2.76A17.28,17.28,0,0,0,339.27,69.68Z",
    fill: "#c7bdba",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.23,55.13a2,2,0,0,1-.24-.91c-.07-.55-.14-3.44-.14-3.44L338,50.64s-.13.88-.3,2.15c-.17-1.27-.3-2.15-.3-2.15l-1.81.14s-.08,2.89-.15,3.44a2.09,2.09,0,0,1-.23.9,8.16,8.16,0,0,0-2,5.39c0,3.16,1.54,5.72,4.49,5.72s4.47-2.56,4.47-5.72A8.17,8.17,0,0,0,340.23,55.13Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.44,50.64c0,.21-.36.42-.84.46s-1-.1-1-.32.43-.44.91-.46S337.42,50.42,337.44,50.64Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,50.64c0,.21.36.42.84.46s.95-.1,1-.32-.43-.44-.91-.46S338.06,50.42,338,50.64Z",
    fill: "#009cdb",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.74,
    cy: 60.36,
    rx: 1.17,
    ry: 2.8,
    fill: "#fff",
    stroke: "#0075bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.39,79.25c2.05-.62,8.92-.26,9.34-.26,0-1.22,0-4.43,0-4.43-2.11,0-7.05.07-8.17.49a8,8,0,0,0-1.46,1.34c3.18.48,2.91.87,0,.51A14.39,14.39,0,0,0,328.39,79.25Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.81,
    cy: 75.69,
    rx: 1.01,
    ry: 0.62,
    transform: "translate(28.29 229.11) rotate(-40.01)",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.24,
    cy: 78.08,
    rx: 0.85,
    ry: 1.18,
    transform: "matrix(0.99, -0.13, 0.13, 0.99, -7.35, 43.15)",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.09,79.25c-2-.62-8.92-.26-9.34-.26,0-1.22,0-4.43,0-4.43,2.11,0,7,.07,8.17.49a8.12,8.12,0,0,1,1.47,1.34c-3.18.48-2.92.87,0,.51A13.9,13.9,0,0,1,347.09,79.25Z",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.67,
    cy: 75.69,
    rx: 0.62,
    ry: 1.01,
    transform: "translate(65.82 292.57) rotate(-49.99)",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.24,
    cy: 78.08,
    rx: 1.18,
    ry: 0.85,
    transform: "translate(224.87 412.29) rotate(-82.56)",
    fill: "#fde284",
    stroke: "#fdaf3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,74.6a14.28,14.28,0,0,1-2.53-.16,9.65,9.65,0,0,1,.1,5.78c-1.16,5.47-.11,7.69.25,10.74a65.83,65.83,0,0,1,.34,7.16c0,.47.57.91,1,1s.85-.16.85-.35V74.6Z",
    fill: "#c7bdba",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,74.6a14.28,14.28,0,0,0,2.53-.16,9.73,9.73,0,0,0-.1,5.78c1.16,5.47.11,7.69-.24,10.74a64.12,64.12,0,0,0-.35,7.16c0,.47-.56.91-1,1s-.85-.16-.85-.35V74.6Z",
    fill: "#c7bdba",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.73,69.53a4.92,4.92,0,0,0-4.46.33c-1.1.8-1.39,0-3.12,1.63s-2.32.79-2.55.82c.33,1.15,1.25,3,2.92,3.09a36.25,36.25,0,0,0,4.51-.53c.75,0,2.14.49,2.7.44Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.34,
    cy: 71.43,
    rx: 1.95,
    ry: 1.02,
    transform: "translate(3.2 156.3) rotate(-26.82)",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,69.53a4.94,4.94,0,0,1,4.47.33c1.1.8,1.39,0,3.11,1.63s2.33.79,2.56.82c-.34,1.15-1.25,3-2.93,3.09a35.8,35.8,0,0,1-4.5-.53c-.75,0-2.14.49-2.71.44Z",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.13,
    cy: 71.43,
    rx: 1.02,
    ry: 1.95,
    transform: "translate(126.2 348.08) rotate(-63.18)",
    fill: "#aaa2a0",
    stroke: "#938b8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Brain_Zoom_Circle_Outline",
    "data-name": "Brain Zoom Circle Outline"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.04,
    cy: 60.7,
    r: 27.1,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TissueLabels"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrows"
  }, /*#__PURE__*/React.createElement("g", {
    className: "HEART-2",
    "data-name": "HEART"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 140.13,
    x2: 331.88,
    y2: 140.13,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.07,
    cy: 140.13,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "LUNG",
    "data-name": "LUNG"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 161.15,
    x2: 298.2,
    y2: 161.15,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.38,
    cy: 161.15,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "VENACV",
    "data-name": "VENACV"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 182,
    x2: 332.06,
    y2: 182,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.24,
    cy: 182,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "HIPPOC",
    "data-name": "HIPPOC"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 54.67,
    x2: 331.45,
    y2: 54.67,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.63,
    cy: 54.67,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "BAT",
    "data-name": "BAT"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 119.06,
    x2: 301.5,
    y2: 119.06,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.68,
    cy: 119.06,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "WAT-SC",
    "data-name": "WAT-SC"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 383.47,
    x2: 301.18,
    y2: 383.47,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.36,
    cy: 383.47,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "LIVER",
    "data-name": "LIVER"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 214.51,
    x2: 319.86,
    y2: 214.51,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.04,
    cy: 214.51,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "SMLINT",
    "data-name": "SMLINT"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 283.07,
    x2: 323.93,
    y2: 283.07,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.11,
    cy: 283.07,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "COLON",
    "data-name": "COLON"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 222.81,
    y1: 360.47,
    x2: 337.94,
    y2: 360.47,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.12,
    cy: 360.47,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "CORTEX",
    "data-name": "CORTEX"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 44.62,
    x2: 348.57,
    y2: 44.62,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.39,
    cy: 44.62,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "HYPOTH",
    "data-name": "HYPOTH"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 63.5,
    x2: 341.32,
    y2: 63.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.14,
    cy: 63.5,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "BLOOD",
    "data-name": "BLOOD"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 152.05,
    x2: 343.56,
    y2: 152.05,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.37,
    cy: 152.05,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "SPLEEN",
    "data-name": "SPLEEN"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 254.96,
    x2: 370.28,
    y2: 254.96,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.1,
    cy: 254.96,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "KIDNEY",
    "data-name": "KIDNEY"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 315.29,
    x2: 386.21,
    y2: 315.29,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.03,
    cy: 315.29,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "OVARY",
    "data-name": "OVARY"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 340.1,
    x2: 394.07,
    y2: 340.1,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.89,
    cy: 340.1,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "TESTES",
    "data-name": "TESTES"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 369.25,
    x2: 354.2,
    y2: 369.25,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.02,
    cy: 369.25,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "ADRNL",
    "data-name": "ADRNL"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 294.39,
    x2: 377.52,
    y2: 294.39,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.33,
    cy: 294.39,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "SKM-GN",
    "data-name": "SKM-GN"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 410.57,
    x2: 371.63,
    y2: 410.57,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.45,
    cy: 410.57,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "SKM-VL",
    "data-name": "SKM-VL"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 453.12,
    y1: 390.13,
    x2: 394.07,
    y2: 390.13,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.89,
    cy: 390.13,
    r: 1.54,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "PLASMA",
    "data-name": "PLASMA",
    x1: 495.76,
    y1: 168.26,
    x2: 495.76,
    y2: 159.73,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    id: "Labels"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "HEART",
    "data-name": "HEART",
    x: 137.81,
    y: 132.63,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#f28b2f",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "HEART",
    "data-name": "HEART"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.28,143.45h-1.11v-3.06H169v3.06h-1.11v-6.78H169v2.77h3.13v-2.77h1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,143.54a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.67-1.93,2.87,2.87,0,0,1,.62-2,2.16,2.16,0,0,1,1.72-.72,2.12,2.12,0,0,1,1.61.61,2.39,2.39,0,0,1,.59,1.7v.59h-3.42a1.68,1.68,0,0,0,.4,1.15,1.4,1.4,0,0,0,1.07.4,3.76,3.76,0,0,0,.85-.09,4.13,4.13,0,0,0,.84-.28v.89a3.33,3.33,0,0,1-.81.26A4.36,4.36,0,0,1,177.29,143.54Zm-.2-4.49a1.1,1.1,0,0,0-.83.33,1.56,1.56,0,0,0-.37,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,177.09,139.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,143.45l-.22-.71h0a2.1,2.1,0,0,1-.75.63,2.23,2.23,0,0,1-1,.17,1.64,1.64,0,0,1-1.18-.4,1.56,1.56,0,0,1-.43-1.16,1.37,1.37,0,0,1,.59-1.2,3.46,3.46,0,0,1,1.8-.44l.88,0V140a1,1,0,0,0-.23-.73.9.9,0,0,0-.71-.25,2.36,2.36,0,0,0-.75.12,7.26,7.26,0,0,0-.7.27l-.35-.78a4.26,4.26,0,0,1,.91-.33,4.53,4.53,0,0,1,.94-.11,2.27,2.27,0,0,1,1.48.42,1.7,1.7,0,0,1,.5,1.34v3.46Zm-1.63-.74a1.32,1.32,0,0,0,1-.33,1.17,1.17,0,0,0,.37-.93V141l-.66,0a2.16,2.16,0,0,0-1.12.26.76.76,0,0,0-.35.7.66.66,0,0,0,.2.53A.86.86,0,0,0,182.17,142.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,138.23a2.7,2.7,0,0,1,.54,0l-.11,1a1.86,1.86,0,0,0-.48-.06,1.42,1.42,0,0,0-1.06.43,1.54,1.54,0,0,0-.4,1.11v2.68h-1.09v-5.13H187l.14.91h.06a2,2,0,0,1,.66-.73A1.6,1.6,0,0,1,188.76,138.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.54,142.66a2.71,2.71,0,0,0,.79-.12v.82a2.64,2.64,0,0,1-.46.13,2.88,2.88,0,0,1-.59,0c-1,0-1.55-.54-1.55-1.63v-2.76H190v-.49l.75-.4.37-1.08h.67v1.14h1.46v.83h-1.46v2.74a.77.77,0,0,0,.2.58A.69.69,0,0,0,192.54,142.66Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "LUNG",
    "data-name": "LUNG",
    x: 137.81,
    y: 153.65,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#04bf8a",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "LUNG",
    "data-name": "LUNG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.84,164.47v-6.78H171v5.83h2.87v.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59,164.47l-.15-.67h-.06a1.63,1.63,0,0,1-.65.56,2.24,2.24,0,0,1-.95.2,1.89,1.89,0,0,1-1.4-.46,2,2,0,0,1-.46-1.41v-3.35H176v3.16a1.41,1.41,0,0,0,.24.89,1,1,0,0,0,.76.29,1.22,1.22,0,0,0,1-.41,2.29,2.29,0,0,0,.32-1.38v-2.55h1.1v5.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,164.47h-1.1v-3.16a1.36,1.36,0,0,0-.24-.88.91.91,0,0,0-.76-.29,1.22,1.22,0,0,0-1,.4,2.3,2.3,0,0,0-.32,1.37v2.56h-1.09v-5.13h.86l.15.67h.05a1.67,1.67,0,0,1,.66-.57,2.27,2.27,0,0,1,.95-.19,1.64,1.64,0,0,1,1.85,1.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5,159.34v.6l-.88.16a1.36,1.36,0,0,1,.2.4,1.38,1.38,0,0,1,.08.5,1.53,1.53,0,0,1-.55,1.25,2.28,2.28,0,0,1-1.5.45,2,2,0,0,1-.45,0,.63.63,0,0,0-.35.51.29.29,0,0,0,.16.27,1.43,1.43,0,0,0,.61.09h.89a2,2,0,0,1,1.29.36,1.25,1.25,0,0,1,.44,1,1.52,1.52,0,0,1-.71,1.35,3.86,3.86,0,0,1-2.08.47,2.83,2.83,0,0,1-1.6-.37,1.2,1.2,0,0,1-.55-1.06,1.1,1.1,0,0,1,.29-.79,1.55,1.55,0,0,1,.84-.45.86.86,0,0,1-.36-.3.78.78,0,0,1-.14-.43.72.72,0,0,1,.16-.49,1.91,1.91,0,0,1,.49-.4,1.39,1.39,0,0,1-.65-.55,1.61,1.61,0,0,1-.25-.91,1.64,1.64,0,0,1,.53-1.3,2.24,2.24,0,0,1,1.5-.45,3.52,3.52,0,0,1,.45,0l.36.06Zm-4,5.93a.61.61,0,0,0,.32.54,1.71,1.71,0,0,0,.89.19,2.71,2.71,0,0,0,1.33-.26.75.75,0,0,0,.43-.67.51.51,0,0,0-.24-.48,2,2,0,0,0-.88-.14h-.83a1.13,1.13,0,0,0-.74.22A.72.72,0,0,0,187.47,165.27Zm.47-4.27a1,1,0,0,0,.25.74.94.94,0,0,0,.71.26c.63,0,.94-.34.94-1a1.13,1.13,0,0,0-.23-.77.89.89,0,0,0-.71-.27,1,1,0,0,0-.72.26A1.17,1.17,0,0,0,187.94,161Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "VENACV",
    "data-name": "VENACV",
    x: 137.81,
    y: 174.5,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#a5415b",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "VENACV",
    "data-name": "VENACV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.22,178.53h1.15L160,185.32h-1.17l-2.36-6.79h1.14l1.41,4.22a6.23,6.23,0,0,1,.24.78c.08.31.14.55.16.7a7.54,7.54,0,0,1,.19-.81c.08-.31.15-.54.2-.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.2,185.41a2.46,2.46,0,0,1-1.87-.7,2.66,2.66,0,0,1-.68-1.92,2.9,2.9,0,0,1,.63-2,2.16,2.16,0,0,1,1.72-.72,2.1,2.1,0,0,1,1.6.62,2.33,2.33,0,0,1,.59,1.7V183h-3.41a1.61,1.61,0,0,0,.4,1.14,1.39,1.39,0,0,0,1.07.41,3.89,3.89,0,0,0,.85-.09,4.21,4.21,0,0,0,.84-.29v.89a3.21,3.21,0,0,1-.81.27A5.12,5.12,0,0,1,165.2,185.41Zm-.2-4.49a1.08,1.08,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.39,1.39,0,0,0-.3-1A1,1,0,0,0,165,180.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.06,185.32H172v-3.16a1.36,1.36,0,0,0-.24-.88.91.91,0,0,0-.76-.3,1.22,1.22,0,0,0-1,.41,2.28,2.28,0,0,0-.32,1.37v2.56h-1.09v-5.13h.86l.15.67h.06a1.45,1.45,0,0,1,.65-.57,2.28,2.28,0,0,1,1-.2,1.65,1.65,0,0,1,1.85,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.83,185.32l-.22-.72h0a2.14,2.14,0,0,1-.75.64,2.41,2.41,0,0,1-1,.17,1.66,1.66,0,0,1-1.18-.41,1.54,1.54,0,0,1-.42-1.16,1.36,1.36,0,0,1,.59-1.19,3.33,3.33,0,0,1,1.79-.44l.89,0v-.27a1.06,1.06,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.68,2.68,0,0,0-.76.11,6,6,0,0,0-.7.28l-.35-.78a3.47,3.47,0,0,1,.92-.33,4,4,0,0,1,.93-.12,2.18,2.18,0,0,1,1.48.43,1.67,1.67,0,0,1,.5,1.34v3.46Zm-1.62-.75a1.36,1.36,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.44l-.66,0a2.3,2.3,0,0,0-1.12.26.79.79,0,0,0-.35.7.73.73,0,0,0,.2.54A.92.92,0,0,0,176.21,184.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,179.39a1.81,1.81,0,0,0-1.5.67,3.54,3.54,0,0,0,0,3.76,1.85,1.85,0,0,0,1.52.64,4.41,4.41,0,0,0,.83-.08c.27-.06.55-.13.84-.22v1a5.07,5.07,0,0,1-1.8.3,2.89,2.89,0,0,1-2.29-.9,3.82,3.82,0,0,1-.8-2.59,4.16,4.16,0,0,1,.39-1.85,2.74,2.74,0,0,1,1.12-1.21,3.4,3.4,0,0,1,1.72-.42,4.29,4.29,0,0,1,1.92.43l-.4.93a5.7,5.7,0,0,0-.72-.29A2.74,2.74,0,0,0,185.6,179.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,185.32l-.21-.72h0a2.14,2.14,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.63,1.63,0,0,1-1.18-.41,1.51,1.51,0,0,1-.43-1.16,1.36,1.36,0,0,1,.59-1.19,3.34,3.34,0,0,1,1.8-.44l.88,0v-.27a1.06,1.06,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.79,2.79,0,0,0-.76.11,5.24,5.24,0,0,0-.69.28l-.36-.78a3.47,3.47,0,0,1,.92-.33,4,4,0,0,1,.94-.12,2.17,2.17,0,0,1,1.47.43,1.64,1.64,0,0,1,.5,1.34v3.46Zm-1.62-.75a1.34,1.34,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.44l-.66,0a2.33,2.33,0,0,0-1.12.26.79.79,0,0,0-.35.7.7.7,0,0,0,.21.54A.89.89,0,0,0,190.34,184.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,185.32l-1.95-5.13h1.15l1,3a6.07,6.07,0,0,1,.33,1.21h0a8.69,8.69,0,0,1,.33-1.21l1-3h1.16l-2,5.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.64,185.32l-.22-.72h0a2,2,0,0,1-.74.64,2.41,2.41,0,0,1-1,.17,1.66,1.66,0,0,1-1.18-.41,1.54,1.54,0,0,1-.42-1.16,1.34,1.34,0,0,1,.59-1.19,3.33,3.33,0,0,1,1.79-.44l.89,0v-.27a1.06,1.06,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.68,2.68,0,0,0-.76.11,6,6,0,0,0-.7.28l-.35-.78a3.35,3.35,0,0,1,.92-.33,4,4,0,0,1,.93-.12,2.18,2.18,0,0,1,1.48.43,1.67,1.67,0,0,1,.5,1.34v3.46Zm-1.62-.75a1.36,1.36,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.44l-.66,0a2.3,2.3,0,0,0-1.12.26.79.79,0,0,0-.35.7.73.73,0,0,0,.2.54A.92.92,0,0,0,201,184.57Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "HIPPOC",
    "data-name": "HIPPOC",
    x: 137.81,
    y: 47.17,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#bf7534",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "HIPPOC",
    "data-name": "HIPPOC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.42,58h-1.11V54.93h-3.13V58h-1.11V51.21h1.11V54h3.13V51.21h1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09,51.5a.56.56,0,0,1,.62-.61.61.61,0,0,1,.45.16.58.58,0,0,1,.16.45.6.6,0,0,1-.16.44.65.65,0,0,1-.45.16.66.66,0,0,1-.46-.16A.64.64,0,0,1,156.09,51.5ZM157.25,58h-1.09V52.86h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.46,58.08a1.8,1.8,0,0,1-1.52-.7h-.06c0,.43.06.7.06.79v2.1h-1.09V52.86h.89l.15.68h.05a1.72,1.72,0,0,1,1.54-.78,1.79,1.79,0,0,1,1.49.7,3.78,3.78,0,0,1,0,3.91A1.76,1.76,0,0,1,161.46,58.08Zm-.27-4.43a1.13,1.13,0,0,0-.95.39,1.94,1.94,0,0,0-.3,1.21v.16a2.38,2.38,0,0,0,.3,1.36,1.11,1.11,0,0,0,1,.42,1,1,0,0,0,.87-.46,2.36,2.36,0,0,0,.31-1.33,2.31,2.31,0,0,0-.3-1.3A1,1,0,0,0,161.19,53.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,58.08a1.79,1.79,0,0,1-1.51-.7h-.06c0,.43.06.7.06.79v2.1h-1.09V52.86h.88c0,.09.08.32.16.68H166a1.71,1.71,0,0,1,1.53-.78,1.81,1.81,0,0,1,1.5.7,3.1,3.1,0,0,1,.53,1.95,3.15,3.15,0,0,1-.54,2A1.78,1.78,0,0,1,167.47,58.08Zm-.26-4.43a1.13,1.13,0,0,0-1,.39,1.94,1.94,0,0,0-.3,1.21v.16a2.38,2.38,0,0,0,.3,1.36,1.11,1.11,0,0,0,1,.42,1,1,0,0,0,.87-.46,2.44,2.44,0,0,0,.31-1.33,2.31,2.31,0,0,0-.31-1.3A1,1,0,0,0,167.21,53.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,55.41a2.79,2.79,0,0,1-.65,2,2.28,2.28,0,0,1-1.79.71,2.49,2.49,0,0,1-1.27-.32,2.16,2.16,0,0,1-.85-.94,3.12,3.12,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-1.95,2.36,2.36,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.78,2.78,0,0,1,175.48,55.41Zm-3.74,0c0,1.19.44,1.78,1.32,1.78s1.29-.59,1.29-1.78-.43-1.76-1.3-1.76a1.14,1.14,0,0,0-1,.46A2.35,2.35,0,0,0,171.74,55.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,58.08a2.25,2.25,0,0,1-1.77-.68,2.8,2.8,0,0,1-.61-1.95,2.86,2.86,0,0,1,.63-2,2.39,2.39,0,0,1,1.83-.7,3.34,3.34,0,0,1,1.47.31l-.33.87a3.28,3.28,0,0,0-1.15-.27c-.88,0-1.33.59-1.33,1.77a2.06,2.06,0,0,0,.34,1.3,1.13,1.13,0,0,0,1,.43,2.84,2.84,0,0,0,1.38-.36v.95a2.44,2.44,0,0,1-.63.25A3.72,3.72,0,0,1,178.93,58.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,58l-.22-.72h0a2,2,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.67,1.67,0,0,1-1.19-.41,1.53,1.53,0,0,1-.42-1.15,1.37,1.37,0,0,1,.59-1.2,3.33,3.33,0,0,1,1.79-.44l.89,0v-.27a1.06,1.06,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.74,2.74,0,0,0-.76.11,5.24,5.24,0,0,0-.69.28l-.36-.78a3.47,3.47,0,0,1,.92-.33,4,4,0,0,1,.94-.12,2.22,2.22,0,0,1,1.47.43,1.65,1.65,0,0,1,.5,1.34V58Zm-1.62-.74a1.36,1.36,0,0,0,.95-.34,1.2,1.2,0,0,0,.36-.93v-.44l-.66,0a2.23,2.23,0,0,0-1.12.25.8.8,0,0,0-.35.71.69.69,0,0,0,.21.53A.89.89,0,0,0,183.3,57.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,58h-1.09V54.82a1.52,1.52,0,0,0-.22-.88.84.84,0,0,0-.7-.29,1.07,1.07,0,0,0-.93.42,2.43,2.43,0,0,0-.29,1.36V58h-1.09V52.86h.85l.16.67h.05A1.49,1.49,0,0,1,189,53a2,2,0,0,1,.89-.2,1.55,1.55,0,0,1,1.57.81h.08a1.53,1.53,0,0,1,.64-.59,2,2,0,0,1,.94-.22,1.72,1.72,0,0,1,1.34.47,2,2,0,0,1,.42,1.41V58h-1.09V54.82a1.45,1.45,0,0,0-.22-.88.85.85,0,0,0-.7-.29,1.08,1.08,0,0,0-.93.4,2,2,0,0,0-.3,1.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,58.08a1.79,1.79,0,0,1-1.51-.7h-.07c.05.43.07.7.07.79v2.1h-1.09V52.86h.88c0,.09.08.32.15.68h.06a1.71,1.71,0,0,1,1.53-.78,1.81,1.81,0,0,1,1.5.7,3.84,3.84,0,0,1,0,3.91A1.79,1.79,0,0,1,199,58.08Zm-.26-4.43a1.11,1.11,0,0,0-.95.39,1.94,1.94,0,0,0-.3,1.21v.16a2.38,2.38,0,0,0,.3,1.36,1.09,1.09,0,0,0,1,.42,1,1,0,0,0,.87-.46,2.45,2.45,0,0,0,.3-1.33,2.31,2.31,0,0,0-.3-1.3A1,1,0,0,0,198.76,53.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,58l-.15-.68h-.06a1.58,1.58,0,0,1-.65.57,2.24,2.24,0,0,1-.95.2,1.89,1.89,0,0,1-1.4-.46,2,2,0,0,1-.46-1.41V52.86h1.1V56a1.3,1.3,0,0,0,.25.88.9.9,0,0,0,.75.3,1.21,1.21,0,0,0,1-.41,2.24,2.24,0,0,0,.32-1.38V52.86h1.1V58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,56.53a1.35,1.35,0,0,1-.54,1.15,2.62,2.62,0,0,1-1.57.4,3.68,3.68,0,0,1-1.65-.31v-.94a4,4,0,0,0,1.68.42c.68,0,1-.21,1-.61a.52.52,0,0,0-.11-.33,1.61,1.61,0,0,0-.37-.27,6.89,6.89,0,0,0-.71-.31,3.3,3.3,0,0,1-1.2-.69,1.3,1.3,0,0,1-.31-.89,1.17,1.17,0,0,1,.53-1,2.57,2.57,0,0,1,1.45-.37,4.17,4.17,0,0,1,1.71.37l-.35.82a3.8,3.8,0,0,0-1.4-.34c-.57,0-.86.16-.86.49a.49.49,0,0,0,.22.41,5.47,5.47,0,0,0,1,.46,4,4,0,0,1,.93.45,1.25,1.25,0,0,1,.42.47A1.29,1.29,0,0,1,212,56.53Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "BAT",
    "data-name": "BAT",
    x: 137.81,
    y: 111.56,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#8c5220",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "BAT",
    "data-name": "BAT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.18,115.6h2a3.81,3.81,0,0,1,2,.41,1.42,1.42,0,0,1,.63,1.29,1.6,1.6,0,0,1-.31,1,1.36,1.36,0,0,1-.88.49v0a1.81,1.81,0,0,1,1.05.53,1.64,1.64,0,0,1,.33,1.08,1.77,1.77,0,0,1-.63,1.43,2.79,2.79,0,0,1-1.78.51h-2.45Zm1.11,2.8h1.07a1.78,1.78,0,0,0,1-.22.82.82,0,0,0,.33-.75.76.76,0,0,0-.35-.69,2.2,2.2,0,0,0-1.1-.21h-1Zm0,.9v2.15h1.18a1.73,1.73,0,0,0,1.05-.27,1,1,0,0,0,.36-.84.9.9,0,0,0-.37-.78,1.9,1.9,0,0,0-1.1-.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.07,117.16a2.61,2.61,0,0,1,.54,0l-.11,1a2.44,2.44,0,0,0-.48,0,1.42,1.42,0,0,0-1.06.42,1.56,1.56,0,0,0-.4,1.11v2.68h-1.09v-5.13h.85l.14.91h.06a2,2,0,0,1,.67-.73A1.55,1.55,0,0,1,155.07,117.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.18,119.81a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.71,2.4,2.4,0,0,1-1.27-.33,2.13,2.13,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-2,2.32,2.32,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.76,2.76,0,0,1,161.18,119.81Zm-3.74,0c0,1.18.44,1.78,1.32,1.78s1.29-.6,1.29-1.78-.43-1.76-1.3-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,157.44,119.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,122.38,166,120c-.08-.25-.23-.84-.44-1.77h0c-.18.84-.32,1.43-.43,1.78l-.68,2.38h-1.2l-1.44-5.13h1.11l.66,2.53c.14.63.25,1.16.31,1.61h0c0-.23.08-.49.14-.78s.12-.51.16-.66l.78-2.7h1.2L167,120c0,.15.1.39.17.7a4.7,4.7,0,0,1,.12.73h0a15.31,15.31,0,0,1,.33-1.6l.66-2.53h1.09l-1.44,5.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,122.38h-1.09v-3.15a1.39,1.39,0,0,0-.24-.89.94.94,0,0,0-.76-.29,1.21,1.21,0,0,0-1,.41,2.28,2.28,0,0,0-.32,1.37v2.55h-1.09v-5.13h.85l.16.68h0a1.53,1.53,0,0,1,.66-.57,2.24,2.24,0,0,1,.95-.2A1.64,1.64,0,0,1,174.9,119Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.21,122.38l-.68-1.88h-2.59l-.66,1.88h-1.17l2.53-6.81h1.21l2.54,6.81Zm-1-2.84-.63-1.84c-.05-.13-.12-.32-.2-.59s-.14-.46-.17-.58a9.79,9.79,0,0,1-.36,1.25l-.62,1.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,122.48a1.77,1.77,0,0,1-1.49-.7,3.1,3.1,0,0,1-.54-2,3.18,3.18,0,0,1,.54-2,1.81,1.81,0,0,1,1.51-.7,1.76,1.76,0,0,1,1.54.75h.06a7.07,7.07,0,0,1-.08-.88v-1.86h1.09v7.21h-.85l-.19-.67h0A1.75,1.75,0,0,1,187,122.48Zm.3-.89a1.21,1.21,0,0,0,1-.37,2.07,2.07,0,0,0,.31-1.23v-.15a2.3,2.3,0,0,0-.31-1.38,1.18,1.18,0,0,0-1-.41,1,1,0,0,0-.89.47,3,3,0,0,0,0,2.63A1,1,0,0,0,187.31,121.59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.19,115.89a.62.62,0,1,1,1.23,0,.55.55,0,0,1-.61.6.61.61,0,0,1-.46-.16A.61.61,0,0,1,191.19,115.89Zm1.16,6.49h-1.09v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.55,122.48a1.82,1.82,0,0,1-1.51-.7H195q.06.64.06.78v2.11H194v-7.42h.88c0,.1.08.33.16.69h0a1.71,1.71,0,0,1,1.53-.78,1.78,1.78,0,0,1,1.5.7,3.1,3.1,0,0,1,.53,2,3.15,3.15,0,0,1-.54,2A1.81,1.81,0,0,1,196.55,122.48Zm-.26-4.43a1.15,1.15,0,0,0-.95.38,2,2,0,0,0-.3,1.22v.16a2.4,2.4,0,0,0,.3,1.36,1.11,1.11,0,0,0,1,.42,1,1,0,0,0,.87-.47,2.43,2.43,0,0,0,.31-1.32,2.34,2.34,0,0,0-.31-1.31A1,1,0,0,0,196.29,118.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,119.81a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.71,2.4,2.4,0,0,1-1.27-.33,2.13,2.13,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-2,2.32,2.32,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.76,2.76,0,0,1,204.56,119.81Zm-3.74,0c0,1.18.44,1.78,1.32,1.78s1.3-.6,1.3-1.78-.44-1.76-1.31-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,200.82,119.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,120.92a1.32,1.32,0,0,1-.55,1.15,2.57,2.57,0,0,1-1.56.41,3.79,3.79,0,0,1-1.65-.31v-1a4,4,0,0,0,1.68.42c.67,0,1-.2,1-.61a.5.5,0,0,0-.11-.32,1.31,1.31,0,0,0-.37-.27,6.58,6.58,0,0,0-.71-.32,3.17,3.17,0,0,1-1.2-.68,1.27,1.27,0,0,1-.31-.89,1.2,1.2,0,0,1,.53-1,2.57,2.57,0,0,1,1.45-.36,4,4,0,0,1,1.71.37l-.35.82a3.85,3.85,0,0,0-1.4-.35c-.58,0-.86.17-.86.5a.47.47,0,0,0,.22.4,4.33,4.33,0,0,0,1,.46,5.41,5.41,0,0,1,.93.45,1.41,1.41,0,0,1,.42.47A1.29,1.29,0,0,1,209.35,120.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,122.48a2.54,2.54,0,0,1-1.88-.7,2.67,2.67,0,0,1-.67-1.93,2.89,2.89,0,0,1,.63-2,2.15,2.15,0,0,1,1.72-.72,2.12,2.12,0,0,1,1.6.62,2.36,2.36,0,0,1,.59,1.7v.58h-3.42a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,4.44,4.44,0,0,0,.84-.08,4.76,4.76,0,0,0,.85-.29v.89a4.28,4.28,0,0,1-.81.27A5.12,5.12,0,0,1,212.88,122.48Zm-.2-4.49a1.14,1.14,0,0,0-.84.32,1.63,1.63,0,0,0-.37,1h2.33a1.44,1.44,0,0,0-.31-1A1,1,0,0,0,212.68,118Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "WAT-SC",
    "data-name": "WAT-SC",
    x: 137.81,
    y: 375.97,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#214da6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "WAT-SC",
    "data-name": "WAT-SC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154,386.79h-1.21l-1.15-4c0-.18-.11-.43-.18-.77s-.12-.56-.14-.69c0,.2-.08.45-.15.77s-.12.55-.17.71l-1.12,4h-1.21l-.88-3.39-.89-3.39H148l1,3.95a16.91,16.91,0,0,1,.33,1.68c0-.26.08-.56.15-.88s.13-.59.19-.79l1.1-4h1.1l1.13,4a16.78,16.78,0,0,1,.35,1.65,10.91,10.91,0,0,1,.33-1.69l1-3.94h1.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,386.79h-1.09v-3.15a1.39,1.39,0,0,0-.24-.89,1,1,0,0,0-.76-.29,1.21,1.21,0,0,0-1,.41,2.21,2.21,0,0,0-.32,1.37v2.55H156.8v-7.22h1.09v1.84a8,8,0,0,1-.06.94h.07a1.57,1.57,0,0,1,.62-.58,2.06,2.06,0,0,1,.93-.2,1.65,1.65,0,0,1,1.86,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,380.3a.61.61,0,0,1,.16-.45.66.66,0,0,1,.46-.16.55.55,0,0,1,.6.61.58.58,0,0,1-.16.44.57.57,0,0,1-.44.16.61.61,0,0,1-.46-.16A.58.58,0,0,1,162.81,380.3Zm1.15,6.49h-1.09v-5.13H164Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,386a2.82,2.82,0,0,0,.8-.12v.82a2.08,2.08,0,0,1-.47.13,2.88,2.88,0,0,1-.59.05c-1,0-1.55-.54-1.55-1.63v-2.76H165V382l.75-.4.37-1.08h.67v1.14h1.46v.83h-1.46v2.74a.75.75,0,0,0,.2.58A.69.69,0,0,0,167.53,386Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64,386.88a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.68-1.93,2.89,2.89,0,0,1,.63-2,2.15,2.15,0,0,1,1.72-.72,2.07,2.07,0,0,1,1.6.62,2.31,2.31,0,0,1,.59,1.69v.59h-3.42a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,4.63,4.63,0,0,0,.85-.08,5,5,0,0,0,.84-.29v.89a4.28,4.28,0,0,1-.81.27A5.18,5.18,0,0,1,171.64,386.88Zm-.2-4.49a1.07,1.07,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,171.44,382.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,386.79l-.68-1.88h-2.59l-.66,1.88h-1.17L179.1,380h1.2l2.54,6.81Zm-1-2.84-.63-1.84c-.05-.13-.11-.32-.2-.59s-.13-.46-.16-.58a12.72,12.72,0,0,1-.37,1.25l-.61,1.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.47,386.88a1.8,1.8,0,0,1-1.5-.69,3.83,3.83,0,0,1,0-3.92,1.82,1.82,0,0,1,1.52-.7,1.8,1.8,0,0,1,1.54.74h.05a6.78,6.78,0,0,1-.08-.87v-1.87h1.1v7.22h-.86l-.19-.67H187A1.74,1.74,0,0,1,185.47,386.88Zm.29-.88a1.17,1.17,0,0,0,1-.38,2,2,0,0,0,.31-1.22v-.16a2.29,2.29,0,0,0-.31-1.37,1.18,1.18,0,0,0-1-.41,1,1,0,0,0-.89.47,2.43,2.43,0,0,0-.31,1.32,2.37,2.37,0,0,0,.3,1.31A1,1,0,0,0,185.76,386Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.64,380.3a.65.65,0,0,1,.16-.45.66.66,0,0,1,.46-.16.56.56,0,0,1,.61.61.62.62,0,0,1-.16.44.61.61,0,0,1-.45.16.61.61,0,0,1-.46-.16A.62.62,0,0,1,189.64,380.3Zm1.16,6.49h-1.09v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,386.88a1.8,1.8,0,0,1-1.52-.7h-.06c0,.44.06.7.06.79v2.1H192.4v-7.41h.89l.15.69h.05a1.71,1.71,0,0,1,1.53-.78,1.8,1.8,0,0,1,1.5.69,3.8,3.8,0,0,1,0,3.92A1.78,1.78,0,0,1,195,386.88Zm-.27-4.42a1.15,1.15,0,0,0-1,.38,2,2,0,0,0-.3,1.21v.17a2.36,2.36,0,0,0,.3,1.35,1.11,1.11,0,0,0,1,.42,1,1,0,0,0,.87-.46,2.34,2.34,0,0,0,.31-1.32,2.26,2.26,0,0,0-.31-1.31A1,1,0,0,0,194.74,382.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,384.22a2.84,2.84,0,0,1-.64,2,2.31,2.31,0,0,1-1.8.7,2.42,2.42,0,0,1-1.27-.32,2.19,2.19,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.83,2.83,0,0,1,.64-2,2.32,2.32,0,0,1,1.81-.7,2.28,2.28,0,0,1,1.76.71A2.81,2.81,0,0,1,203,384.22Zm-3.73,0c0,1.18.43,1.77,1.31,1.77s1.3-.59,1.3-1.77-.44-1.76-1.31-1.76a1.13,1.13,0,0,0-1,.45A2.4,2.4,0,0,0,199.28,384.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.8,385.33a1.34,1.34,0,0,1-.54,1.15,2.62,2.62,0,0,1-1.57.4,3.68,3.68,0,0,1-1.65-.31v-.94a4,4,0,0,0,1.68.42c.68,0,1-.2,1-.61a.48.48,0,0,0-.11-.32,1.18,1.18,0,0,0-.37-.27,6.58,6.58,0,0,0-.71-.32,3.47,3.47,0,0,1-1.2-.68A1.32,1.32,0,0,1,204,383a1.2,1.2,0,0,1,.53-1,2.57,2.57,0,0,1,1.45-.36,4,4,0,0,1,1.71.37l-.35.82a3.85,3.85,0,0,0-1.4-.35c-.57,0-.86.17-.86.49a.49.49,0,0,0,.22.41,4.83,4.83,0,0,0,1,.46,5.41,5.41,0,0,1,.93.45,1.32,1.32,0,0,1,.42.47A1.29,1.29,0,0,1,207.8,385.33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,386.88a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.68-1.93,2.89,2.89,0,0,1,.63-2,2.15,2.15,0,0,1,1.72-.72,2.07,2.07,0,0,1,1.6.62,2.31,2.31,0,0,1,.59,1.69v.59H209.9a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,4.63,4.63,0,0,0,.85-.08,5,5,0,0,0,.84-.29v.89a4.28,4.28,0,0,1-.81.27A5.18,5.18,0,0,1,211.33,386.88Zm-.2-4.49a1.07,1.07,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,211.13,382.39Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "LIVER",
    "data-name": "LIVER",
    x: 137.81,
    y: 207.01,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#da6c75",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "LIVER",
    "data-name": "LIVER"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.77,217.83v-6.78h1.11v5.83h2.87v1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.84,211.34a.58.58,0,0,1,.16-.45.61.61,0,0,1,.46-.16.57.57,0,0,1,.44.16.7.7,0,0,1,0,.89.61.61,0,0,1-.44.16.66.66,0,0,1-.46-.16A.58.58,0,0,1,174.84,211.34Zm1.16,6.49h-1.09V212.7H176Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,217.83l-2-5.13h1.15l1.05,3a5.4,5.4,0,0,1,.32,1.22h0a9.36,9.36,0,0,1,.32-1.22l1-3H182l-2,5.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.08,217.92a2.46,2.46,0,0,1-1.87-.7,2.63,2.63,0,0,1-.68-1.92,2.86,2.86,0,0,1,.63-2,2.16,2.16,0,0,1,1.72-.72,2.13,2.13,0,0,1,1.61.61,2.37,2.37,0,0,1,.59,1.7v.59h-3.42a1.68,1.68,0,0,0,.4,1.15,1.39,1.39,0,0,0,1.07.4A3.82,3.82,0,0,0,186,217a4.13,4.13,0,0,0,.84-.28v.88a3.09,3.09,0,0,1-.81.27A4.36,4.36,0,0,1,185.08,217.92Zm-.2-4.49a1.1,1.1,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1H186a1.38,1.38,0,0,0-.3-1A1,1,0,0,0,184.88,213.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,212.61a2.7,2.7,0,0,1,.54,0l-.11,1a1.86,1.86,0,0,0-.48-.06,1.37,1.37,0,0,0-1.06.43,1.53,1.53,0,0,0-.41,1.11v2.68h-1.09V212.7h.86l.14.9h.06a2.12,2.12,0,0,1,.66-.73A1.68,1.68,0,0,1,191,212.61Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "SMLINT",
    "data-name": "SMLINT",
    x: 137.81,
    y: 275.57,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#a18277",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "SMLINT",
    "data-name": "SMLINT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.51,284.55a1.73,1.73,0,0,1-.65,1.42,2.88,2.88,0,0,1-1.81.51,4.44,4.44,0,0,1-1.88-.35v-1.05a5.25,5.25,0,0,0,1,.34,4.32,4.32,0,0,0,1,.13,1.59,1.59,0,0,0,1-.25.89.89,0,0,0,0-1.32,4.33,4.33,0,0,0-1.19-.63,3,3,0,0,1-1.31-.86,1.82,1.82,0,0,1-.38-1.16,1.62,1.62,0,0,1,.6-1.33,2.47,2.47,0,0,1,1.62-.49,4.67,4.67,0,0,1,1.94.43l-.35.9a4.29,4.29,0,0,0-1.62-.38,1.19,1.19,0,0,0-.81.24.75.75,0,0,0-.28.62.94.94,0,0,0,.11.45,1.25,1.25,0,0,0,.37.35,5.76,5.76,0,0,0,.92.44,5.22,5.22,0,0,1,1.09.58,1.72,1.72,0,0,1,.51.61A1.81,1.81,0,0,1,150.51,284.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.12,286.39H155v-3.16a1.4,1.4,0,0,0-.23-.88.79.79,0,0,0-.69-.29,1.06,1.06,0,0,0-.93.41,2.45,2.45,0,0,0-.29,1.36v2.56H151.8v-5.13h.85l.16.67h.05a1.41,1.41,0,0,1,.62-.56,1.91,1.91,0,0,1,.89-.2,1.57,1.57,0,0,1,1.57.8H156a1.53,1.53,0,0,1,.64-.59,2,2,0,0,1,.94-.21,1.73,1.73,0,0,1,1.34.46,2.06,2.06,0,0,1,.42,1.42v3.34h-1.09v-3.16a1.34,1.34,0,0,0-.23-.88.8.8,0,0,0-.69-.29,1.07,1.07,0,0,0-.93.39,2,2,0,0,0-.3,1.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.13,286.39l-.22-.71h0a2.1,2.1,0,0,1-.75.63,2.23,2.23,0,0,1-1,.17,1.59,1.59,0,0,1-1.18-.41,1.49,1.49,0,0,1-.43-1.15,1.37,1.37,0,0,1,.59-1.2,3.43,3.43,0,0,1,1.8-.44l.88,0V283a1,1,0,0,0-.23-.73.9.9,0,0,0-.71-.25,2.42,2.42,0,0,0-.76.12,7.07,7.07,0,0,0-.69.27l-.36-.78a4.35,4.35,0,0,1,.92-.33,4.53,4.53,0,0,1,.94-.11,2.22,2.22,0,0,1,1.47.42,1.67,1.67,0,0,1,.5,1.34v3.46Zm-1.62-.74a1.34,1.34,0,0,0,1-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.22,2.22,0,0,0-1.12.26.78.78,0,0,0-.35.7.66.66,0,0,0,.21.53A.84.84,0,0,0,162.51,285.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.58,286.39h-1.09v-7.22h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,286.39h-1.09v-7.22h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,286.39v-6.78h1.11v6.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,286.39h-1.09v-3.15a1.37,1.37,0,0,0-.24-.89.91.91,0,0,0-.76-.29,1.18,1.18,0,0,0-1,.41,2.24,2.24,0,0,0-.32,1.36v2.56h-1.09v-5.13h.85l.16.67h0a1.58,1.58,0,0,1,.66-.56,2.1,2.1,0,0,1,1-.2,1.64,1.64,0,0,1,1.84,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,285.6a2.82,2.82,0,0,0,.8-.12v.82a2.78,2.78,0,0,1-.47.13,2.88,2.88,0,0,1-.59.05c-1,0-1.55-.54-1.55-1.63v-2.76h-.7v-.49l.75-.4.37-1.08h.67v1.14H186v.83h-1.46v2.74a.77.77,0,0,0,.2.58A.69.69,0,0,0,185.26,285.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.37,286.48a2.46,2.46,0,0,1-1.87-.7,2.63,2.63,0,0,1-.68-1.92,2.88,2.88,0,0,1,.63-2,2.16,2.16,0,0,1,1.72-.72,2.1,2.1,0,0,1,1.6.61,2.35,2.35,0,0,1,.59,1.7v.59h-3.42a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,3.89,3.89,0,0,0,.85-.09,4.13,4.13,0,0,0,.84-.28v.89a3.63,3.63,0,0,1-.81.26A4.36,4.36,0,0,1,189.37,286.48Zm-.2-4.49a1.07,1.07,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.43,1.43,0,0,0-.3-1A1.06,1.06,0,0,0,189.17,282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,284.93a1.36,1.36,0,0,1-.55,1.15,2.6,2.6,0,0,1-1.57.4,3.63,3.63,0,0,1-1.64-.31v-.94a4,4,0,0,0,1.68.42c.67,0,1-.2,1-.61a.44.44,0,0,0-.12-.32,1.12,1.12,0,0,0-.36-.27,5.67,5.67,0,0,0-.71-.32,3.3,3.3,0,0,1-1.2-.69,1.24,1.24,0,0,1-.31-.89,1.15,1.15,0,0,1,.53-1,2.51,2.51,0,0,1,1.44-.36,4.1,4.1,0,0,1,1.71.36l-.35.82a4,4,0,0,0-1.39-.34c-.58,0-.87.17-.87.49a.5.5,0,0,0,.23.41,4.57,4.57,0,0,0,1,.46,4.12,4.12,0,0,1,.92.45,1.36,1.36,0,0,1,.43.47A1.41,1.41,0,0,1,196.19,284.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.52,285.6a2.71,2.71,0,0,0,.79-.12v.82a2.64,2.64,0,0,1-.46.13,2.88,2.88,0,0,1-.59.05c-1,0-1.55-.54-1.55-1.63v-2.76H197v-.49l.75-.4.37-1.08h.67v1.14h1.46v.83H198.8v2.74a.77.77,0,0,0,.2.58A.69.69,0,0,0,199.52,285.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.34,279.9a.61.61,0,0,1,.16-.45.64.64,0,0,1,.46-.16.55.55,0,0,1,.6.61.58.58,0,0,1-.16.44.57.57,0,0,1-.44.16.6.6,0,0,1-.46-.16A.58.58,0,0,1,201.34,279.9Zm1.15,6.49H201.4v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,286.39h-1.09v-3.15a1.37,1.37,0,0,0-.24-.89.91.91,0,0,0-.76-.29,1.18,1.18,0,0,0-1,.41,2.18,2.18,0,0,0-.32,1.36v2.56H204.1v-5.13H205l.16.67h0a1.58,1.58,0,0,1,.66-.56,2.1,2.1,0,0,1,1-.2,1.64,1.64,0,0,1,1.84,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.46,286.48a2.46,2.46,0,0,1-1.87-.7,2.63,2.63,0,0,1-.68-1.92,2.88,2.88,0,0,1,.63-2,2.15,2.15,0,0,1,1.72-.72,2.1,2.1,0,0,1,1.6.61,2.35,2.35,0,0,1,.59,1.7v.59H211a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,3.89,3.89,0,0,0,.85-.09,4.13,4.13,0,0,0,.84-.28v.89a3.63,3.63,0,0,1-.81.26A4.36,4.36,0,0,1,212.46,286.48Zm-.2-4.49a1.07,1.07,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,212.26,282Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "COLON",
    "data-name": "COLON",
    x: 137.81,
    y: 352.97,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#5a2e15",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "COLON",
    "data-name": "COLON"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.81,357.86a1.85,1.85,0,0,0-1.51.68,3.6,3.6,0,0,0,0,3.76,1.85,1.85,0,0,0,1.53.64,3.84,3.84,0,0,0,.83-.09,7.48,7.48,0,0,0,.84-.22v.95a4.87,4.87,0,0,1-1.81.31,2.89,2.89,0,0,1-2.29-.91,3.77,3.77,0,0,1-.79-2.58,4.3,4.3,0,0,1,.38-1.85,2.8,2.8,0,0,1,1.12-1.21,3.44,3.44,0,0,1,1.73-.43,4.3,4.3,0,0,1,1.92.44l-.4.92a5.26,5.26,0,0,0-.73-.28A2.63,2.63,0,0,0,170.81,357.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,361.22a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.71,2.4,2.4,0,0,1-1.27-.33,2.08,2.08,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-2,2.31,2.31,0,0,1,1.8-.7,2.27,2.27,0,0,1,1.77.72A2.76,2.76,0,0,1,178.38,361.22Zm-3.74,0c0,1.18.44,1.78,1.32,1.78s1.29-.6,1.29-1.78-.43-1.76-1.3-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,174.64,361.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.81,363.79h-1.09v-7.21h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,361.22a2.79,2.79,0,0,1-.65,2,2.3,2.3,0,0,1-1.79.71,2.43,2.43,0,0,1-1.27-.33,2.13,2.13,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.83,2.83,0,0,1,.64-2,2.32,2.32,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.76,2.76,0,0,1,187,361.22Zm-3.74,0c0,1.18.44,1.78,1.32,1.78s1.3-.6,1.3-1.78-.44-1.76-1.31-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,183.27,361.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.86,363.79h-1.1v-3.15a1.39,1.39,0,0,0-.24-.89.94.94,0,0,0-.76-.29,1.22,1.22,0,0,0-1,.41,2.28,2.28,0,0,0-.32,1.37v2.55h-1.09v-5.13h.86l.15.68h.05a1.53,1.53,0,0,1,.66-.57,2.28,2.28,0,0,1,.95-.2,1.65,1.65,0,0,1,1.85,1.88Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "CORTEX",
    "data-name": "CORTEX",
    x: 453.12,
    y: 37.32,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#f2e751",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "CORTEX",
    "data-name": "CORTEX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.91,42.22a1.84,1.84,0,0,0-1.51.67,3.6,3.6,0,0,0,0,3.76,1.85,1.85,0,0,0,1.53.64,3.77,3.77,0,0,0,.83-.09,7.48,7.48,0,0,0,.84-.22v1a4.87,4.87,0,0,1-1.81.31,2.85,2.85,0,0,1-2.28-.91,3.73,3.73,0,0,1-.8-2.58,4.16,4.16,0,0,1,.39-1.85,2.68,2.68,0,0,1,1.12-1.21,3.38,3.38,0,0,1,1.72-.43,4.3,4.3,0,0,1,1.92.44l-.4.92a6.93,6.93,0,0,0-.73-.28A2.63,2.63,0,0,0,483.91,42.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.48,45.57a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.71,2.4,2.4,0,0,1-1.27-.33,2.13,2.13,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-2,2.32,2.32,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.76,2.76,0,0,1,491.48,45.57Zm-3.74,0c0,1.18.44,1.78,1.32,1.78s1.3-.6,1.3-1.78-.44-1.76-1.31-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,487.74,45.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.41,42.92a2.79,2.79,0,0,1,.55,0l-.11,1a2.52,2.52,0,0,0-.48,0,1.4,1.4,0,0,0-1.06.42,1.57,1.57,0,0,0-.41,1.11v2.68h-1.09V43h.85l.15.91h.05a2.05,2.05,0,0,1,.67-.73A1.57,1.57,0,0,1,495.41,42.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.19,47.35a2.77,2.77,0,0,0,.8-.12v.82a2.08,2.08,0,0,1-.47.13,2.81,2.81,0,0,1-.59.06c-1,0-1.55-.55-1.55-1.64V43.84h-.7v-.48l.75-.4.38-1.09h.67V43h1.46v.83h-1.46v2.74a.75.75,0,0,0,.2.59A.72.72,0,0,0,499.19,47.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.3,48.24a2.5,2.5,0,0,1-1.87-.7,2.66,2.66,0,0,1-.67-1.92,2.9,2.9,0,0,1,.62-2,2.16,2.16,0,0,1,1.72-.72,2.12,2.12,0,0,1,1.61.62,2.36,2.36,0,0,1,.59,1.7v.58h-3.42a1.66,1.66,0,0,0,.4,1.15,1.4,1.4,0,0,0,1.07.4,3.78,3.78,0,0,0,.85-.08A4.21,4.21,0,0,0,505,47v.89a3.43,3.43,0,0,1-.8.27A5.32,5.32,0,0,1,503.3,48.24Zm-.2-4.49a1.1,1.1,0,0,0-.83.33,1.54,1.54,0,0,0-.37,1h2.33a1.44,1.44,0,0,0-.31-1A1,1,0,0,0,503.1,43.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.8,45.52,506.08,43h1.24l1.17,1.8,1.18-1.8h1.23l-1.72,2.51L511,48.14h-1.23l-1.27-1.92-1.26,1.92H506Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "HYPOTH",
    "data-name": "HYPOTH",
    x: 453.12,
    y: 56.2,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#f2b443",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "HYPOTH",
    "data-name": "HYPOTH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.79,67h-1.11V64h-3.13v3h-1.11V60.24h1.11V63h3.13V60.24h1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.86,61.89h1.19l1,2.91a5.72,5.72,0,0,1,.32,1.17h0a4.39,4.39,0,0,1,.16-.62c.07-.24.46-1.4,1.18-3.46H474l-2.19,5.81a2.08,2.08,0,0,1-2,1.6,3.26,3.26,0,0,1-.7-.07v-.87a2.34,2.34,0,0,0,.56.06,1.15,1.15,0,0,0,1.11-.92l.19-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.51,67.12a1.81,1.81,0,0,1-1.51-.7h-.06q.06.64.06.78v2.1h-1.09V61.89h.88c0,.1.08.33.16.69H476a1.71,1.71,0,0,1,1.53-.78,1.78,1.78,0,0,1,1.5.7,3.84,3.84,0,0,1,0,3.91A1.81,1.81,0,0,1,477.51,67.12Zm-.26-4.43a1.15,1.15,0,0,0-.95.38,2,2,0,0,0-.3,1.22v.16a2.36,2.36,0,0,0,.3,1.35,1.11,1.11,0,0,0,1,.42,1,1,0,0,0,.87-.46,2.43,2.43,0,0,0,.31-1.32,2.34,2.34,0,0,0-.31-1.31A1,1,0,0,0,477.25,62.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.52,64.45a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.71,2.4,2.4,0,0,1-1.27-.33,2.19,2.19,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-2,2.32,2.32,0,0,1,1.81-.7,2.26,2.26,0,0,1,1.76.72A2.76,2.76,0,0,1,485.52,64.45Zm-3.74,0q0,1.77,1.32,1.77t1.29-1.77c0-1.17-.43-1.76-1.3-1.76a1.13,1.13,0,0,0-1,.45A2.39,2.39,0,0,0,481.78,64.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.73,66.23a2.82,2.82,0,0,0,.8-.12v.82a2.08,2.08,0,0,1-.47.13,2.88,2.88,0,0,1-.59.06c-1,0-1.55-.55-1.55-1.64V62.72h-.7v-.48l.75-.4.37-1.09H488v1.14h1.47v.83H488v2.74a.79.79,0,0,0,.2.59A.73.73,0,0,0,488.73,66.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.13,67H494V63.87a1.39,1.39,0,0,0-.24-.89.92.92,0,0,0-.75-.29,1.21,1.21,0,0,0-1,.41,2.22,2.22,0,0,0-.32,1.38V67h-1.09V59.8h1.09v1.84a8,8,0,0,1-.06.94h.07a1.51,1.51,0,0,1,.62-.58,2,2,0,0,1,.92-.2,1.66,1.66,0,0,1,1.87,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.9,67l-.22-.71h0a2.25,2.25,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.67,1.67,0,0,1-1.19-.41,1.54,1.54,0,0,1-.42-1.16,1.34,1.34,0,0,1,.59-1.19,3.41,3.41,0,0,1,1.79-.45l.89,0v-.28a1,1,0,0,0-.23-.73.94.94,0,0,0-.71-.25,2.42,2.42,0,0,0-.76.12,7.07,7.07,0,0,0-.69.27l-.36-.78a4.35,4.35,0,0,1,.92-.33,4.53,4.53,0,0,1,.94-.11,2.17,2.17,0,0,1,1.47.43,1.64,1.64,0,0,1,.5,1.34V67Zm-1.62-.74a1.36,1.36,0,0,0,1-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.33,2.33,0,0,0-1.12.26.79.79,0,0,0-.35.7.66.66,0,0,0,.21.53A.84.84,0,0,0,498.28,66.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35,67h-1.09V59.8h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.18,67l-.22-.71h0a2.14,2.14,0,0,1-.74.64,2.41,2.41,0,0,1-1,.17,1.66,1.66,0,0,1-1.18-.41,1.54,1.54,0,0,1-.42-1.16,1.32,1.32,0,0,1,.59-1.19,3.41,3.41,0,0,1,1.79-.45l.89,0v-.28a1,1,0,0,0-.23-.73.94.94,0,0,0-.71-.25,2.37,2.37,0,0,0-.76.12c-.24.08-.47.17-.7.27l-.35-.78a4.16,4.16,0,0,1,.92-.33,4.52,4.52,0,0,1,.93-.11,2.2,2.2,0,0,1,1.48.43,1.67,1.67,0,0,1,.5,1.34V67Zm-1.62-.74a1.36,1.36,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.3,2.3,0,0,0-1.12.26.79.79,0,0,0-.35.7.69.69,0,0,0,.2.53A.87.87,0,0,0,506.56,66.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.86,67h-1.09V63.86a1.42,1.42,0,0,0-.23-.88.82.82,0,0,0-.69-.29,1.08,1.08,0,0,0-.93.41,2.47,2.47,0,0,0-.29,1.37V67h-1.09V61.89h.85l.16.67h.05a1.41,1.41,0,0,1,.62-.56,2,2,0,0,1,.89-.2,1.56,1.56,0,0,1,1.57.81h.08a1.49,1.49,0,0,1,.64-.6,2,2,0,0,1,.94-.21,1.73,1.73,0,0,1,1.34.46,2.06,2.06,0,0,1,.42,1.42V67H517V63.86a1.43,1.43,0,0,0-.22-.88.86.86,0,0,0-.7-.29,1.05,1.05,0,0,0-.93.4,2,2,0,0,0-.3,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.3,67l-.15-.67h-.06a1.56,1.56,0,0,1-.65.56,2.11,2.11,0,0,1-1,.21,1.89,1.89,0,0,1-1.4-.47,2,2,0,0,1-.46-1.4V61.89h1.1v3.17a1.38,1.38,0,0,0,.24.88.93.93,0,0,0,.76.29,1.18,1.18,0,0,0,1-.41,2.21,2.21,0,0,0,.32-1.37V61.89h1.1V67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.29,65.56a1.34,1.34,0,0,1-.54,1.15,2.62,2.62,0,0,1-1.57.41,3.67,3.67,0,0,1-1.65-.32v-.94a4,4,0,0,0,1.68.42c.68,0,1-.2,1-.61a.48.48,0,0,0-.11-.32,1.18,1.18,0,0,0-.37-.27,6.58,6.58,0,0,0-.71-.32,3.31,3.31,0,0,1-1.2-.68,1.32,1.32,0,0,1-.31-.89,1.2,1.2,0,0,1,.53-1,2.57,2.57,0,0,1,1.45-.36,4,4,0,0,1,1.71.37l-.35.82a3.85,3.85,0,0,0-1.4-.35c-.58,0-.86.17-.86.5a.47.47,0,0,0,.22.4,4.83,4.83,0,0,0,1,.46,5.06,5.06,0,0,1,.93.45,1.41,1.41,0,0,1,.42.47A1.29,1.29,0,0,1,529.29,65.56Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "BLOOD",
    "data-name": "BLOOD",
    x: 453.12,
    y: 144.75,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#d92c04",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "BLOOD",
    "data-name": "BLOOD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.38,155.58h-1.2L471,151.53c0-.18-.11-.43-.19-.76s-.12-.57-.13-.7c0,.2-.08.46-.15.77s-.13.55-.18.71l-1.12,4h-1.2l-.88-3.4-.89-3.39h1.13l1,4a16,16,0,0,1,.32,1.67c0-.26.09-.55.16-.88s.13-.58.18-.79l1.11-4h1.1l1.13,4a14.69,14.69,0,0,1,.34,1.65,12.13,12.13,0,0,1,.34-1.68l1-4h1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.71,155.58h-1.1v-3.16a1.34,1.34,0,0,0-.24-.88.91.91,0,0,0-.76-.3,1.23,1.23,0,0,0-1,.41,2.34,2.34,0,0,0-.32,1.38v2.55h-1.09v-7.22h1.09v1.83c0,.29,0,.61,0,.94h.07a1.4,1.4,0,0,1,.61-.57,2,2,0,0,1,.93-.21,1.66,1.66,0,0,1,1.87,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.86,153a2.79,2.79,0,0,1-.64,2,2.32,2.32,0,0,1-1.8.71,2.43,2.43,0,0,1-1.27-.33,2.08,2.08,0,0,1-.85-.93A3.12,3.12,0,0,1,482,153a2.83,2.83,0,0,1,.64-1.95,2.36,2.36,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.78,2.78,0,0,1,486.86,153Zm-3.73,0c0,1.19.43,1.78,1.31,1.78s1.3-.59,1.3-1.78-.44-1.76-1.31-1.76a1.09,1.09,0,0,0-1,.46A2.25,2.25,0,0,0,483.13,153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.29,155.58H488.2v-7.22h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.18,155.67a2.46,2.46,0,0,1-1.87-.7,2.66,2.66,0,0,1-.68-1.92,2.9,2.9,0,0,1,.63-2,2.16,2.16,0,0,1,1.72-.72,2.1,2.1,0,0,1,1.6.62,2.33,2.33,0,0,1,.59,1.7v.59h-3.41a1.65,1.65,0,0,0,.4,1.14,1.39,1.39,0,0,0,1.07.41,3.82,3.82,0,0,0,.85-.09,4.21,4.21,0,0,0,.84-.29v.89a3.21,3.21,0,0,1-.81.27A5.12,5.12,0,0,1,493.18,155.67Zm-.2-4.49a1.08,1.08,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.44,1.44,0,0,0-.3-1A1.08,1.08,0,0,0,493,151.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,148.79h2a3.81,3.81,0,0,1,2,.41,1.42,1.42,0,0,1,.63,1.29,1.52,1.52,0,0,1-.31,1,1.39,1.39,0,0,1-.88.5v0a1.75,1.75,0,0,1,1,.53,1.61,1.61,0,0,1,.34,1.08,1.73,1.73,0,0,1-.64,1.43,2.78,2.78,0,0,1-1.77.52H499Zm1.11,2.81h1.06a1.81,1.81,0,0,0,1-.23.83.83,0,0,0,.32-.74.78.78,0,0,0-.35-.7,2.16,2.16,0,0,0-1.09-.21h-1Zm0,.9v2.14h1.17a1.76,1.76,0,0,0,1.05-.26,1,1,0,0,0,.36-.85.89.89,0,0,0-.36-.78,1.92,1.92,0,0,0-1.1-.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.38,155.58h-1.09v-7.22h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.58,153a2.79,2.79,0,0,1-.65,2,2.3,2.3,0,0,1-1.79.71,2.43,2.43,0,0,1-1.27-.33,2.08,2.08,0,0,1-.85-.93,3.12,3.12,0,0,1-.3-1.41,2.83,2.83,0,0,1,.64-1.95,2.36,2.36,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.78,2.78,0,0,1,512.58,153Zm-3.74,0c0,1.19.44,1.78,1.32,1.78s1.3-.59,1.3-1.78-.44-1.76-1.31-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,508.84,153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.49,153a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.71,2.4,2.4,0,0,1-1.27-.33,2.08,2.08,0,0,1-.85-.93,3.12,3.12,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-1.95,2.36,2.36,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.78,2.78,0,0,1,518.49,153Zm-3.74,0c0,1.19.44,1.78,1.32,1.78s1.3-.59,1.3-1.78-.44-1.76-1.31-1.76a1.11,1.11,0,0,0-1,.46A2.33,2.33,0,0,0,514.75,153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.6,155.67a1.78,1.78,0,0,1-1.5-.7,3.8,3.8,0,0,1,0-3.92,1.81,1.81,0,0,1,1.51-.7,1.78,1.78,0,0,1,1.54.75h.05a7.1,7.1,0,0,1-.08-.87v-1.87h1.1v7.22h-.86l-.19-.68h0A1.74,1.74,0,0,1,521.6,155.67Zm.29-.88a1.2,1.2,0,0,0,1-.38,2,2,0,0,0,.31-1.23V153a2.3,2.3,0,0,0-.31-1.38,1.18,1.18,0,0,0-1-.41,1,1,0,0,0-.89.47,2.44,2.44,0,0,0-.31,1.33,2.25,2.25,0,0,0,.31,1.3A1,1,0,0,0,521.89,154.79Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "PLASMA",
    "data-name": "PLASMA",
    x: 453.12,
    y: 168.25,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#f1997c",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "PLASMA",
    "data-name": "PLASMA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.23,174.34a2,2,0,0,1-.69,1.63,3.13,3.13,0,0,1-2,.56h-.71v2.54h-1.11v-6.78h2a2.93,2.93,0,0,1,1.9.52A1.85,1.85,0,0,1,484.23,174.34Zm-3.38,1.26h.59a2.07,2.07,0,0,0,1.25-.3,1.08,1.08,0,0,0,.4-.93,1,1,0,0,0-.36-.87,1.76,1.76,0,0,0-1.11-.29h-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.57,179.07h-1.09v-7.22h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.39,179.07l-.21-.72h0a2,2,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.59,1.59,0,0,1-1.18-.41,1.49,1.49,0,0,1-.43-1.15,1.37,1.37,0,0,1,.59-1.2,3.43,3.43,0,0,1,1.8-.44l.88,0v-.27a1,1,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.46,2.46,0,0,0-.76.12,5.2,5.2,0,0,0-.69.27l-.35-.78a4.07,4.07,0,0,1,.91-.33,3.94,3.94,0,0,1,.94-.11,2.22,2.22,0,0,1,1.47.42,1.65,1.65,0,0,1,.5,1.34v3.46Zm-1.62-.74a1.34,1.34,0,0,0,1-.33,1.24,1.24,0,0,0,.36-.94v-.44l-.66,0a2.34,2.34,0,0,0-1.12.25.8.8,0,0,0-.35.71.68.68,0,0,0,.21.53A.89.89,0,0,0,489.77,178.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.26,177.61a1.33,1.33,0,0,1-.55,1.15,2.57,2.57,0,0,1-1.56.4,3.65,3.65,0,0,1-1.65-.31v-.94a4,4,0,0,0,1.68.42c.68,0,1-.21,1-.61a.52.52,0,0,0-.11-.33,1.55,1.55,0,0,0-.37-.26,5.06,5.06,0,0,0-.71-.32,3.3,3.3,0,0,1-1.2-.69,1.3,1.3,0,0,1-.31-.89,1.17,1.17,0,0,1,.53-1,2.57,2.57,0,0,1,1.45-.36,4.16,4.16,0,0,1,1.71.36l-.35.82a3.8,3.8,0,0,0-1.4-.34c-.58,0-.86.16-.86.49a.49.49,0,0,0,.22.41,5.47,5.47,0,0,0,1,.46,4.24,4.24,0,0,1,.93.45,1.32,1.32,0,0,1,.42.47A1.29,1.29,0,0,1,497.26,177.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.86,179.07h-1.09v-3.16a1.4,1.4,0,0,0-.23-.88.79.79,0,0,0-.69-.29,1.06,1.06,0,0,0-.93.41,2.45,2.45,0,0,0-.29,1.36v2.56h-1.09v-5.13h.85l.15.67h.06a1.41,1.41,0,0,1,.62-.56,1.91,1.91,0,0,1,.89-.2,1.56,1.56,0,0,1,1.57.8h.07a1.65,1.65,0,0,1,.64-.59,2.11,2.11,0,0,1,.95-.21,1.73,1.73,0,0,1,1.34.46,2,2,0,0,1,.42,1.41v3.35H505v-3.16a1.4,1.4,0,0,0-.23-.88.8.8,0,0,0-.69-.29,1.07,1.07,0,0,0-.93.39,2,2,0,0,0-.3,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.87,179.07l-.22-.72h0a2,2,0,0,1-.75.64,2.41,2.41,0,0,1-1,.17,1.62,1.62,0,0,1-1.18-.41,1.52,1.52,0,0,1-.42-1.15,1.37,1.37,0,0,1,.59-1.2,3.42,3.42,0,0,1,1.79-.44l.89,0v-.27a1.07,1.07,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.42,2.42,0,0,0-.76.12,5.2,5.2,0,0,0-.69.27l-.36-.78a4.35,4.35,0,0,1,.92-.33,3.92,3.92,0,0,1,.93-.11,2.23,2.23,0,0,1,1.48.42,1.68,1.68,0,0,1,.5,1.34v3.46Zm-1.62-.74a1.36,1.36,0,0,0,.95-.33,1.24,1.24,0,0,0,.36-.94v-.44l-.66,0a2.31,2.31,0,0,0-1.12.25.8.8,0,0,0-.35.71.68.68,0,0,0,.21.53A.89.89,0,0,0,509.25,178.33Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "SPLEEN",
    "data-name": "SPLEEN",
    x: 453.12,
    y: 247.66,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#f3c288",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "SPLEEN",
    "data-name": "SPLEEN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.78,256.64a1.7,1.7,0,0,1-.66,1.42,2.83,2.83,0,0,1-1.8.51,4.23,4.23,0,0,1-1.88-.35v-1.05a4.92,4.92,0,0,0,1,.34,3.87,3.87,0,0,0,1,.13,1.57,1.57,0,0,0,1-.25.83.83,0,0,0,.32-.68.85.85,0,0,0-.29-.64,4.45,4.45,0,0,0-1.19-.63,3.19,3.19,0,0,1-1.31-.85,1.86,1.86,0,0,1-.38-1.16,1.6,1.6,0,0,1,.61-1.34,2.52,2.52,0,0,1,1.62-.49,4.62,4.62,0,0,1,1.93.43l-.35.9a4.28,4.28,0,0,0-1.61-.38,1.23,1.23,0,0,0-.82.24.78.78,0,0,0-.28.62.94.94,0,0,0,.11.45,1.25,1.25,0,0,0,.37.35,5.35,5.35,0,0,0,.92.44,5.44,5.44,0,0,1,1.09.58,1.73,1.73,0,0,1,.52.61A2,2,0,0,1,484.78,256.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.67,258.57a1.8,1.8,0,0,1-1.52-.7h-.06c0,.44.06.7.06.79v2.1h-1.09v-7.41h.88c0,.1.08.33.16.69h0a1.71,1.71,0,0,1,1.53-.78,1.8,1.8,0,0,1,1.5.69,3.8,3.8,0,0,1,0,3.92A1.78,1.78,0,0,1,488.67,258.57Zm-.27-4.42a1.15,1.15,0,0,0-.95.38,2,2,0,0,0-.3,1.21v.17a2.36,2.36,0,0,0,.3,1.35,1.11,1.11,0,0,0,1,.42,1,1,0,0,0,.87-.46,2.34,2.34,0,0,0,.31-1.32,2.26,2.26,0,0,0-.31-1.31A1,1,0,0,0,488.4,254.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.18,258.48h-1.09v-7.22h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.07,258.57a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.68-1.93,2.89,2.89,0,0,1,.63-2,2.15,2.15,0,0,1,1.72-.72,2.07,2.07,0,0,1,1.6.62,2.31,2.31,0,0,1,.59,1.69v.59h-3.42a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,4.63,4.63,0,0,0,.85-.08,5,5,0,0,0,.84-.29v.89a4.28,4.28,0,0,1-.81.27A5.18,5.18,0,0,1,497.07,258.57Zm-.2-4.49a1.07,1.07,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1H498a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,496.87,254.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.67,258.57a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.67-1.93,2.89,2.89,0,0,1,.62-2,2.16,2.16,0,0,1,1.72-.72,2.09,2.09,0,0,1,1.61.62,2.35,2.35,0,0,1,.59,1.69v.59h-3.42a1.68,1.68,0,0,0,.4,1.15,1.4,1.4,0,0,0,1.07.4,4.46,4.46,0,0,0,.85-.08,5,5,0,0,0,.84-.29v.89a4,4,0,0,1-.8.27A5.37,5.37,0,0,1,502.67,258.57Zm-.2-4.49a1.1,1.1,0,0,0-.83.33,1.56,1.56,0,0,0-.37,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,502.47,254.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.53,258.48h-1.09v-3.15a1.39,1.39,0,0,0-.24-.89,1,1,0,0,0-.76-.29,1.21,1.21,0,0,0-1,.41,2.21,2.21,0,0,0-.32,1.37v2.55H506v-5.13h.85l.15.67h.06a1.46,1.46,0,0,1,.66-.56,2.09,2.09,0,0,1,.94-.2,1.65,1.65,0,0,1,1.85,1.88Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "KIDNEY",
    "data-name": "KIDNEY",
    x: 453.12,
    y: 308,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#7553a7",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "KIDNEY",
    "data-name": "KIDNEY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.82,318.82h-1.29l-2.13-3.07-.65.53v2.54h-1.11V312h1.11v3.23c.3-.37.6-.72.9-1.07l1.84-2.16h1.26l-2.55,3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.76,312.33a.58.58,0,0,1,.16-.45.61.61,0,0,1,.46-.16.61.61,0,0,1,.45.16.61.61,0,0,1,.16.45.64.64,0,0,1-.16.44.65.65,0,0,1-.45.16.66.66,0,0,1-.46-.16A.6.6,0,0,1,486.76,312.33Zm1.16,6.49h-1.09v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.29,318.91a1.8,1.8,0,0,1-1.5-.69,3.8,3.8,0,0,1,0-3.92,1.8,1.8,0,0,1,1.51-.7,1.76,1.76,0,0,1,1.54.74h.06a5.54,5.54,0,0,1-.08-.87V311.6h1.09v7.22h-.85l-.19-.67h-.05A1.75,1.75,0,0,1,491.29,318.91Zm.29-.88a1.19,1.19,0,0,0,1-.38,2,2,0,0,0,.32-1.23v-.15a2.34,2.34,0,0,0-.32-1.38,1.17,1.17,0,0,0-1-.4,1,1,0,0,0-.88.46,2.38,2.38,0,0,0-.31,1.33,2.34,2.34,0,0,0,.3,1.3A1,1,0,0,0,491.58,318Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,318.82H499v-3.16a1.36,1.36,0,0,0-.24-.88.91.91,0,0,0-.76-.29,1.2,1.2,0,0,0-1,.4,2.3,2.3,0,0,0-.32,1.37v2.56h-1.09v-5.13h.85l.16.67h0a1.67,1.67,0,0,1,.66-.57,2.27,2.27,0,0,1,.95-.19,1.64,1.64,0,0,1,1.84,1.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.89,318.91a2.46,2.46,0,0,1-1.87-.7,2.63,2.63,0,0,1-.68-1.92,2.9,2.9,0,0,1,.63-2,2.16,2.16,0,0,1,1.72-.71,2.1,2.1,0,0,1,1.6.61,2.33,2.33,0,0,1,.59,1.7v.59h-3.42a1.73,1.73,0,0,0,.41,1.15,1.43,1.43,0,0,0,1.07.4,3.82,3.82,0,0,0,.85-.09,4.86,4.86,0,0,0,.84-.28v.88a3.21,3.21,0,0,1-.81.27A5.12,5.12,0,0,1,503.89,318.91Zm-.2-4.49a1.08,1.08,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.43,1.43,0,0,0-.3-1A1,1,0,0,0,503.69,314.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,313.69h1.19l1,2.91a5.14,5.14,0,0,1,.32,1.17h0a3.22,3.22,0,0,1,.15-.62c.07-.25.47-1.4,1.18-3.46h1.18l-2.2,5.81a2.07,2.07,0,0,1-2,1.6,3.36,3.36,0,0,1-.71-.08v-.86a2.43,2.43,0,0,0,.56,0,1.14,1.14,0,0,0,1.11-.91l.19-.48Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "ADRNL",
    "data-name": "ADRNL",
    x: 453.12,
    y: 286.89,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "plum",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "ADRNL",
    "data-name": "ADRNL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.52,297.71l-.68-1.89h-2.59l-.66,1.89h-1.17L480,290.9h1.2l2.54,6.81Zm-1-2.84-.63-1.85c-.05-.12-.11-.32-.2-.58s-.14-.46-.17-.59a9.79,9.79,0,0,1-.36,1.25l-.61,1.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.33,297.8a1.78,1.78,0,0,1-1.5-.7,3.1,3.1,0,0,1-.54-2,3.13,3.13,0,0,1,.54-2,1.82,1.82,0,0,1,1.51-.71,1.76,1.76,0,0,1,1.54.75h.06a7.1,7.1,0,0,1-.08-.87v-1.87H489v7.22h-.86l-.19-.68h-.05A1.74,1.74,0,0,1,486.33,297.8Zm.29-.88a1.2,1.2,0,0,0,1-.38,2,2,0,0,0,.31-1.23v-.15a2.3,2.3,0,0,0-.31-1.38,1.18,1.18,0,0,0-1-.41,1,1,0,0,0-.89.47,2.44,2.44,0,0,0-.31,1.33,2.34,2.34,0,0,0,.3,1.3A1,1,0,0,0,486.62,296.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.17,292.48a2.61,2.61,0,0,1,.54,0l-.11,1a2.44,2.44,0,0,0-.48-.05,1.37,1.37,0,0,0-1.06.43,1.53,1.53,0,0,0-.41,1.1v2.69h-1.09v-5.13h.86l.14.9h.06a2,2,0,0,1,.66-.73A1.6,1.6,0,0,1,493.17,292.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,297.8a2.46,2.46,0,0,1-1.87-.7,2.65,2.65,0,0,1-.68-1.92,2.9,2.9,0,0,1,.63-2,2.16,2.16,0,0,1,1.72-.72,2.14,2.14,0,0,1,1.61.62,2.37,2.37,0,0,1,.59,1.7v.59h-3.42a1.65,1.65,0,0,0,.4,1.14,1.39,1.39,0,0,0,1.07.41,3.76,3.76,0,0,0,.85-.09,4.21,4.21,0,0,0,.84-.29v.89a3.09,3.09,0,0,1-.81.27A5.12,5.12,0,0,1,497,297.8Zm-.2-4.49a1.1,1.1,0,0,0-.83.33,1.56,1.56,0,0,0-.37,1h2.32a1.35,1.35,0,0,0-.3-1A1,1,0,0,0,496.76,293.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.82,297.71h-1.1v-3.16a1.42,1.42,0,0,0-.23-.88.92.92,0,0,0-.76-.3,1.21,1.21,0,0,0-1,.41,2.21,2.21,0,0,0-.32,1.37v2.56h-1.09v-5.13h.85l.15.67h.06a1.42,1.42,0,0,1,.66-.57,2.23,2.23,0,0,1,.94-.2,1.65,1.65,0,0,1,1.85,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.59,297.71l-.22-.72h0a2.14,2.14,0,0,1-.75.64,2.41,2.41,0,0,1-1,.17,1.66,1.66,0,0,1-1.18-.41,1.54,1.54,0,0,1-.42-1.16,1.36,1.36,0,0,1,.59-1.19,3.33,3.33,0,0,1,1.79-.44l.89,0v-.27a1.06,1.06,0,0,0-.23-.74.94.94,0,0,0-.71-.24,2.74,2.74,0,0,0-.76.11,5.24,5.24,0,0,0-.69.28l-.36-.78a3.47,3.47,0,0,1,.92-.33,4,4,0,0,1,.94-.12,2.17,2.17,0,0,1,1.47.43,1.64,1.64,0,0,1,.5,1.34v3.46ZM508,297a1.36,1.36,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.44l-.66,0a2.33,2.33,0,0,0-1.12.26.79.79,0,0,0-.35.7.7.7,0,0,0,.21.54A.89.89,0,0,0,508,297Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,297.71H512v-7.22H513Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "SKM-GN",
    "data-name": "SKM-GN",
    x: 453.12,
    y: 402.86,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#088c03",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "SKM-GN",
    "data-name": "SKM-GN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.07,410h2.49v3.41a6.82,6.82,0,0,1-1.17.28,7.81,7.81,0,0,1-1.22.08,3.06,3.06,0,0,1-2.38-.91,3.68,3.68,0,0,1-.83-2.57,3.42,3.42,0,0,1,.94-2.56,3.53,3.53,0,0,1,2.59-.93,5.14,5.14,0,0,1,2,.41l-.39.92a4,4,0,0,0-1.65-.38,2.21,2.21,0,0,0-1.72.69,2.62,2.62,0,0,0-.63,1.86,2.77,2.77,0,0,0,.57,1.89,2.06,2.06,0,0,0,1.63.65,5.3,5.3,0,0,0,1.15-.14V411h-1.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.36,413.68l-.22-.71h0a2.25,2.25,0,0,1-.75.64,2.42,2.42,0,0,1-1,.16,1.66,1.66,0,0,1-1.18-.4,1.54,1.54,0,0,1-.42-1.16,1.34,1.34,0,0,1,.59-1.19,3.41,3.41,0,0,1,1.79-.45l.89,0v-.28a1,1,0,0,0-.23-.73.94.94,0,0,0-.71-.25,2.42,2.42,0,0,0-.76.12,7.07,7.07,0,0,0-.69.27l-.36-.78a4.35,4.35,0,0,1,.92-.33,4.52,4.52,0,0,1,.93-.11,2.18,2.18,0,0,1,1.48.43,1.67,1.67,0,0,1,.5,1.34v3.45Zm-1.62-.74a1.36,1.36,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.3,2.3,0,0,0-1.12.26.79.79,0,0,0-.35.7.66.66,0,0,0,.21.53A.84.84,0,0,0,469.74,412.94Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.23,412.22a1.32,1.32,0,0,1-.55,1.15,2.57,2.57,0,0,1-1.56.4,3.65,3.65,0,0,1-1.65-.31v-.94a4,4,0,0,0,1.68.42c.67,0,1-.2,1-.61a.48.48,0,0,0-.11-.32,1.31,1.31,0,0,0-.37-.27,7.64,7.64,0,0,0-.71-.32,3.31,3.31,0,0,1-1.2-.68,1.27,1.27,0,0,1-.31-.89,1.2,1.2,0,0,1,.53-1,2.55,2.55,0,0,1,1.45-.36,4,4,0,0,1,1.71.37l-.36.82a3.76,3.76,0,0,0-1.39-.35c-.58,0-.86.17-.86.5a.47.47,0,0,0,.22.4,4.83,4.83,0,0,0,1,.46,5.24,5.24,0,0,1,.92.45,1.35,1.35,0,0,1,.43.47A1.41,1.41,0,0,1,477.23,412.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.56,412.89a2.82,2.82,0,0,0,.8-.12v.82a2.08,2.08,0,0,1-.47.13,2.88,2.88,0,0,1-.59,0c-1,0-1.55-.54-1.55-1.63v-2.76h-.7v-.48l.75-.4.37-1.09h.67v1.14h1.47v.83h-1.47v2.74a.79.79,0,0,0,.2.59A.73.73,0,0,0,480.56,412.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.05,408.46a2.61,2.61,0,0,1,.54.05l-.11,1a1.86,1.86,0,0,0-.48,0,1.42,1.42,0,0,0-1.06.42,1.56,1.56,0,0,0-.4,1.11v2.68h-1.09v-5.13h.85l.14.91h.06a2,2,0,0,1,.66-.73A1.6,1.6,0,0,1,485.05,408.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.16,411.11a2.79,2.79,0,0,1-.65,2,2.31,2.31,0,0,1-1.79.7,2.4,2.4,0,0,1-1.27-.32,2.13,2.13,0,0,1-.85-.93,3.18,3.18,0,0,1-.3-1.41,2.78,2.78,0,0,1,.64-1.95,2.32,2.32,0,0,1,1.81-.7,2.25,2.25,0,0,1,1.76.72A2.76,2.76,0,0,1,491.16,411.11Zm-3.74,0q0,1.77,1.32,1.77t1.29-1.77c0-1.17-.43-1.76-1.3-1.76a1.13,1.13,0,0,0-1,.45A2.39,2.39,0,0,0,487.42,411.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.61,413.77a2.24,2.24,0,0,1-1.77-.67,2.83,2.83,0,0,1-.61-2,2.89,2.89,0,0,1,.63-2,2.38,2.38,0,0,1,1.83-.69,3.48,3.48,0,0,1,1.47.3l-.33.88a3.33,3.33,0,0,0-1.15-.27c-.88,0-1.33.59-1.33,1.77a2.12,2.12,0,0,0,.33,1.29,1.17,1.17,0,0,0,1,.44,2.69,2.69,0,0,0,1.37-.37v.95a2,2,0,0,1-.62.25A3.72,3.72,0,0,1,494.61,413.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.81,413.68h-1.1v-3.15a1.39,1.39,0,0,0-.24-.89.94.94,0,0,0-.76-.29,1.22,1.22,0,0,0-1,.41,2.28,2.28,0,0,0-.32,1.37v2.55h-1.09v-5.13h.86l.15.67h.06a1.49,1.49,0,0,1,.65-.56,2.28,2.28,0,0,1,.95-.2,1.65,1.65,0,0,1,1.85,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.65,413.77a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.67-1.93,2.89,2.89,0,0,1,.62-2,2.16,2.16,0,0,1,1.72-.72,2.09,2.09,0,0,1,1.61.62,2.35,2.35,0,0,1,.59,1.69v.59h-3.42a1.68,1.68,0,0,0,.4,1.15,1.4,1.4,0,0,0,1.07.4,4.46,4.46,0,0,0,.85-.08,5,5,0,0,0,.84-.29v.89a3.85,3.85,0,0,1-.81.27A5.18,5.18,0,0,1,505.65,413.77Zm-.2-4.49a1.14,1.14,0,0,0-.83.33,1.56,1.56,0,0,0-.37,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,505.45,409.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.32,413.68h-1.09v-3.16a1.42,1.42,0,0,0-.23-.88.83.83,0,0,0-.69-.29,1.08,1.08,0,0,0-.93.41,2.38,2.38,0,0,0-.29,1.37v2.55H509v-5.13h.85l.15.67h.06a1.41,1.41,0,0,1,.62-.56,2,2,0,0,1,.89-.2,1.56,1.56,0,0,1,1.57.81h.07a1.61,1.61,0,0,1,.64-.6,2.08,2.08,0,0,1,.95-.21,1.73,1.73,0,0,1,1.34.46,2.06,2.06,0,0,1,.42,1.42v3.34h-1.09v-3.16a1.42,1.42,0,0,0-.23-.88.84.84,0,0,0-.7-.29,1.08,1.08,0,0,0-.93.4,2.07,2.07,0,0,0-.29,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.07,407.19a.54.54,0,0,1,.61-.6.64.64,0,0,1,.45.15.61.61,0,0,1,.16.45.58.58,0,0,1-.16.44.61.61,0,0,1-.45.16.55.55,0,0,1-.61-.6Zm1.15,6.49h-1.09v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.45,413.68l-.15-.67h-.06a1.49,1.49,0,0,1-.65.56,2.1,2.1,0,0,1-1,.2,1.89,1.89,0,0,1-1.4-.46,2,2,0,0,1-.46-1.4v-3.36h1.1v3.17a1.38,1.38,0,0,0,.24.88.93.93,0,0,0,.76.29,1.19,1.19,0,0,0,1-.41,2.28,2.28,0,0,0,.32-1.37v-2.56h1.1v5.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.44,412.22a1.34,1.34,0,0,1-.54,1.15,2.62,2.62,0,0,1-1.57.4,3.65,3.65,0,0,1-1.65-.31v-.94a4,4,0,0,0,1.68.42c.68,0,1-.2,1-.61a.48.48,0,0,0-.11-.32,1.18,1.18,0,0,0-.37-.27,6.58,6.58,0,0,0-.71-.32,3.31,3.31,0,0,1-1.2-.68,1.32,1.32,0,0,1-.31-.89,1.2,1.2,0,0,1,.53-1,2.57,2.57,0,0,1,1.45-.36,4,4,0,0,1,1.71.37l-.35.82a3.85,3.85,0,0,0-1.4-.35c-.57,0-.86.17-.86.5a.47.47,0,0,0,.22.4,4.83,4.83,0,0,0,1,.46,5.41,5.41,0,0,1,.93.45,1.41,1.41,0,0,1,.42.47A1.29,1.29,0,0,1,530.44,412.22Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "SKM-VL",
    "data-name": "SKM-VL",
    x: 453.12,
    y: 382.42,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#025939",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "SKM-VL",
    "data-name": "SKM-VL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.67,386.46h1.15l-2.37,6.78h-1.17l-2.37-6.78h1.14l1.42,4.22c.07.2.15.46.23.78s.14.55.17.7q.06-.35.18-.81c.09-.31.15-.54.21-.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.66,393.24l-.22-.71h0a2.25,2.25,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.64,1.64,0,0,1-1.18-.41,1.55,1.55,0,0,1-.43-1.16,1.35,1.35,0,0,1,.59-1.19,3.37,3.37,0,0,1,1.8-.44l.88,0v-.28a1,1,0,0,0-.23-.73.94.94,0,0,0-.71-.24,2.35,2.35,0,0,0-.75.11,5.38,5.38,0,0,0-.7.28l-.35-.78a3.8,3.8,0,0,1,.91-.34,4.53,4.53,0,0,1,.94-.11,2.22,2.22,0,0,1,1.48.43,1.67,1.67,0,0,1,.5,1.34v3.45ZM467,392.5a1.37,1.37,0,0,0,1-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.27,2.27,0,0,0-1.12.26.77.77,0,0,0-.35.7.66.66,0,0,0,.2.53A.86.86,0,0,0,467,392.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.52,391.78a1.37,1.37,0,0,1-.54,1.16,2.69,2.69,0,0,1-1.57.4,3.85,3.85,0,0,1-1.65-.31v-.95a4.07,4.07,0,0,0,1.69.42c.67,0,1-.2,1-.61a.45.45,0,0,0-.11-.32,1.12,1.12,0,0,0-.36-.27,7.64,7.64,0,0,0-.71-.32,3.09,3.09,0,0,1-1.2-.68,1.28,1.28,0,0,1-.32-.89,1.16,1.16,0,0,1,.54-1,2.44,2.44,0,0,1,1.44-.37,4,4,0,0,1,1.71.37l-.35.82a3.8,3.8,0,0,0-1.4-.35c-.57,0-.86.17-.86.5a.5.5,0,0,0,.22.41,5.17,5.17,0,0,0,1,.45,5.24,5.24,0,0,1,.92.45,1.49,1.49,0,0,1,.43.48A1.36,1.36,0,0,1,474.52,391.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.85,392.46a2.79,2.79,0,0,0,.8-.13v.82a2.08,2.08,0,0,1-.47.13,2.81,2.81,0,0,1-.59.06c-1,0-1.55-.55-1.55-1.64v-2.76h-.7v-.48l.75-.4.38-1.09h.67v1.14h1.46v.83h-1.46v2.75a.74.74,0,0,0,.2.58A.73.73,0,0,0,477.85,392.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.35,393.24l-.15-.67h-.06a1.46,1.46,0,0,1-.64.56,2.12,2.12,0,0,1-1,.21,1.87,1.87,0,0,1-1.39-.47,1.89,1.89,0,0,1-.46-1.4v-3.36h1.1v3.17a1.38,1.38,0,0,0,.24.88.91.91,0,0,0,.76.3,1.18,1.18,0,0,0,1-.42,2.2,2.2,0,0,0,.33-1.37v-2.56h1.09v5.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.35,391.78a1.37,1.37,0,0,1-.55,1.16,2.69,2.69,0,0,1-1.57.4,3.85,3.85,0,0,1-1.65-.31v-.95a4.07,4.07,0,0,0,1.69.42c.67,0,1-.2,1-.61a.45.45,0,0,0-.12-.32,1.12,1.12,0,0,0-.36-.27,7.64,7.64,0,0,0-.71-.32,3.17,3.17,0,0,1-1.2-.68,1.27,1.27,0,0,1-.31-.89,1.15,1.15,0,0,1,.53-1,2.44,2.44,0,0,1,1.44-.37,4,4,0,0,1,1.71.37l-.35.82a3.8,3.8,0,0,0-1.4-.35c-.57,0-.86.17-.86.5a.52.52,0,0,0,.23.41,4.7,4.7,0,0,0,1,.45,5.24,5.24,0,0,1,.92.45,1.38,1.38,0,0,1,.43.48A1.36,1.36,0,0,1,489.35,391.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.11,393.24v-6.78h1.11v5.83h2.87v.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.62,393.24l-.22-.71h0a2.25,2.25,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.64,1.64,0,0,1-1.18-.41,1.55,1.55,0,0,1-.43-1.16,1.35,1.35,0,0,1,.59-1.19,3.37,3.37,0,0,1,1.8-.44l.88,0v-.28a1,1,0,0,0-.23-.73.94.94,0,0,0-.71-.24,2.35,2.35,0,0,0-.75.11,5.38,5.38,0,0,0-.7.28l-.35-.78a3.8,3.8,0,0,1,.91-.34,4.53,4.53,0,0,1,.94-.11,2.22,2.22,0,0,1,1.48.43,1.67,1.67,0,0,1,.5,1.34v3.45ZM500,392.5a1.37,1.37,0,0,0,1-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.27,2.27,0,0,0-1.12.26.77.77,0,0,0-.35.7.66.66,0,0,0,.2.53A.86.86,0,0,0,500,392.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.89,392.46a2.79,2.79,0,0,0,.8-.13v.82a2.08,2.08,0,0,1-.47.13,2.81,2.81,0,0,1-.59.06c-1,0-1.55-.55-1.55-1.64v-2.76h-.7v-.48l.75-.4.38-1.09h.67v1.14h1.46v.83h-1.46v2.75a.74.74,0,0,0,.2.58A.73.73,0,0,0,505.89,392.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510,393.34a2.51,2.51,0,0,1-1.87-.7,2.66,2.66,0,0,1-.67-1.92,2.9,2.9,0,0,1,.62-2,2.16,2.16,0,0,1,1.72-.72,2.12,2.12,0,0,1,1.61.62,2.36,2.36,0,0,1,.59,1.7v.58h-3.42a1.66,1.66,0,0,0,.4,1.15,1.4,1.4,0,0,0,1.07.4,3.78,3.78,0,0,0,.85-.08,4.21,4.21,0,0,0,.84-.29V393a3,3,0,0,1-.8.27A5.32,5.32,0,0,1,510,393.34Zm-.2-4.49a1.1,1.1,0,0,0-.83.33,1.56,1.56,0,0,0-.37,1h2.33a1.44,1.44,0,0,0-.31-1A1.08,1.08,0,0,0,509.8,388.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,388a2.61,2.61,0,0,1,.54.05l-.11,1a2.44,2.44,0,0,0-.48-.05,1.42,1.42,0,0,0-1.06.42,1.56,1.56,0,0,0-.4,1.11v2.68h-1.09v-5.13h.85l.14.91h.06a2,2,0,0,1,.67-.73A1.55,1.55,0,0,1,516,388Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.66,393.24l-.22-.71h0a2.25,2.25,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.67,1.67,0,0,1-1.19-.41,1.54,1.54,0,0,1-.42-1.16,1.35,1.35,0,0,1,.59-1.19,3.33,3.33,0,0,1,1.79-.44l.89,0v-.28a1,1,0,0,0-.23-.73.94.94,0,0,0-.71-.24,2.41,2.41,0,0,0-.76.11,5.24,5.24,0,0,0-.69.28l-.36-.78a3.88,3.88,0,0,1,.92-.34,4.53,4.53,0,0,1,.94-.11,2.17,2.17,0,0,1,1.47.43,1.64,1.64,0,0,1,.5,1.34v3.45ZM519,392.5a1.36,1.36,0,0,0,1-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.33,2.33,0,0,0-1.12.26.79.79,0,0,0-.35.7.66.66,0,0,0,.21.53A.84.84,0,0,0,519,392.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.11,393.24H523V386h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.66,386.75a.61.61,0,0,1,.16-.45.63.63,0,0,1,.45-.15.54.54,0,0,1,.61.6.57.57,0,0,1-.16.44.58.58,0,0,1-.45.16.59.59,0,0,1-.45-.16A.57.57,0,0,1,525.66,386.75Zm1.15,6.49h-1.09v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.93,391.78a1.35,1.35,0,0,1-.55,1.16,2.67,2.67,0,0,1-1.57.4,3.77,3.77,0,0,1-1.64-.31v-.95a4,4,0,0,0,1.68.42c.67,0,1-.2,1-.61a.5.5,0,0,0-.11-.32,1.31,1.31,0,0,0-.37-.27,7.64,7.64,0,0,0-.71-.32,3.17,3.17,0,0,1-1.2-.68,1.27,1.27,0,0,1-.31-.89,1.15,1.15,0,0,1,.53-1,2.44,2.44,0,0,1,1.44-.37,4,4,0,0,1,1.72.37l-.36.82a3.8,3.8,0,0,0-1.39-.35c-.58,0-.87.17-.87.5a.52.52,0,0,0,.23.41,5,5,0,0,0,1,.45,5.24,5.24,0,0,1,.92.45,1.38,1.38,0,0,1,.43.48A1.36,1.36,0,0,1,531.93,391.78Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "OVARY",
    "data-name": "OVARY",
    x: 453.12,
    y: 332.8,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#f2ced0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "OVARY",
    "data-name": "OVARY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.22,341.18v1h.67a.22.22,0,0,1,.22.22v.74a.22.22,0,0,1-.22.23h-.67V344a.22.22,0,0,1-.22.23h-.75A.22.22,0,0,1,480,344v-.66h-.67a.22.22,0,0,1-.22-.23v-.74a.22.22,0,0,1,.22-.22H480v-1a2.68,2.68,0,1,1,1.19,0Zm-.59-1.12a1.49,1.49,0,1,0-1.49-1.48A1.49,1.49,0,0,0,480.63,340.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.11,340.22a3.73,3.73,0,0,1-.82,2.58,3.47,3.47,0,0,1-4.71,0,4.46,4.46,0,0,1,0-5.17,3,3,0,0,1,2.36-.9,3,3,0,0,1,2.34.92A3.69,3.69,0,0,1,492.11,340.22Zm-5.17,0a3.08,3.08,0,0,0,.5,1.9,1.8,1.8,0,0,0,1.5.65,1.76,1.76,0,0,0,1.49-.64,3,3,0,0,0,.51-1.91,3.06,3.06,0,0,0-.5-1.89,2.07,2.07,0,0,0-3,0A3,3,0,0,0,486.94,340.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.85,343.62l-2-5.13h1.15l1.05,3a5.93,5.93,0,0,1,.32,1.21h0a7.9,7.9,0,0,1,.32-1.21l1.05-3H498l-2,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,343.62l-.21-.71h0a2.25,2.25,0,0,1-.75.64,2.39,2.39,0,0,1-1,.17,1.63,1.63,0,0,1-1.18-.41,1.52,1.52,0,0,1-.43-1.16,1.34,1.34,0,0,1,.59-1.19,3.43,3.43,0,0,1,1.8-.45l.88,0v-.28a1,1,0,0,0-.23-.73.9.9,0,0,0-.71-.25,2.46,2.46,0,0,0-.76.12,7.07,7.07,0,0,0-.69.27l-.35-.78a4.07,4.07,0,0,1,.91-.33,4.53,4.53,0,0,1,.94-.11,2.17,2.17,0,0,1,1.47.43,1.64,1.64,0,0,1,.5,1.34v3.45Zm-1.62-.74a1.34,1.34,0,0,0,.95-.33,1.2,1.2,0,0,0,.36-.93v-.45l-.66,0a2.33,2.33,0,0,0-1.12.26.79.79,0,0,0-.35.7.66.66,0,0,0,.21.53A.84.84,0,0,0,500.42,342.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,338.4a2.19,2.19,0,0,1,.55.05l-.11,1a1.91,1.91,0,0,0-.48,0,1.4,1.4,0,0,0-1.06.42,1.57,1.57,0,0,0-.41,1.11v2.68H504.4v-5.13h.85l.15.91h.05a2.05,2.05,0,0,1,.67-.73A1.57,1.57,0,0,1,507,338.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.19,338.49h1.19l1,2.91a5.14,5.14,0,0,1,.32,1.17h0a3.22,3.22,0,0,1,.15-.62c.07-.24.47-1.4,1.18-3.46h1.18l-2.2,5.81a2.07,2.07,0,0,1-2,1.6,3.29,3.29,0,0,1-.71-.07V345a2.34,2.34,0,0,0,.56.06,1.15,1.15,0,0,0,1.11-.92l.19-.48Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "TESTES",
    "data-name": "TESTES",
    x: 453.12,
    y: 361.95,
    width: 85,
    height: 15,
    rx: 7.5,
    fill: "#6d86a5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "TESTES",
    "data-name": "TESTES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485,365.87v1.47a.22.22,0,0,1-.38.15l-.32-.31-1.49,1.5a2.65,2.65,0,0,1,.41,1.42,2.67,2.67,0,1,1-1.25-2.26l1.49-1.5-.31-.31a.22.22,0,0,1,.16-.38h1.46A.22.22,0,0,1,485,365.87Zm-3,4.23a1.49,1.49,0,1,0-1.49,1.48A1.49,1.49,0,0,0,482,370.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.13,372.77H489v-5.83h-2V366h5.1v.95h-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.73,372.86a2.49,2.49,0,0,1-1.87-.69,2.67,2.67,0,0,1-.68-1.93,2.89,2.89,0,0,1,.63-2,2.15,2.15,0,0,1,1.72-.72,2.07,2.07,0,0,1,1.6.62,2.31,2.31,0,0,1,.59,1.69v.59H493.3a1.68,1.68,0,0,0,.41,1.15,1.39,1.39,0,0,0,1.07.4,4.44,4.44,0,0,0,.84-.08,4.76,4.76,0,0,0,.85-.29v.89a4.28,4.28,0,0,1-.81.27A5.18,5.18,0,0,1,494.73,372.86Zm-.2-4.49a1.07,1.07,0,0,0-.83.33,1.57,1.57,0,0,0-.38,1h2.33a1.43,1.43,0,0,0-.31-1A1,1,0,0,0,494.53,368.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.55,371.31a1.34,1.34,0,0,1-.55,1.15,2.62,2.62,0,0,1-1.57.4,3.71,3.71,0,0,1-1.65-.31v-.94a4.07,4.07,0,0,0,1.69.42c.67,0,1-.2,1-.61a.43.43,0,0,0-.11-.32,1.12,1.12,0,0,0-.36-.27,7.64,7.64,0,0,0-.71-.32,3.31,3.31,0,0,1-1.2-.68,1.27,1.27,0,0,1-.31-.89,1.18,1.18,0,0,1,.53-1,2.51,2.51,0,0,1,1.44-.36,4,4,0,0,1,1.71.37l-.35.82a3.8,3.8,0,0,0-1.4-.35c-.57,0-.86.17-.86.49a.49.49,0,0,0,.23.41,4.57,4.57,0,0,0,1,.46,5.24,5.24,0,0,1,.92.45,1.46,1.46,0,0,1,.43.47A1.41,1.41,0,0,1,501.55,371.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.87,372a2.72,2.72,0,0,0,.8-.12v.82a2,2,0,0,1-.46.13,2.92,2.92,0,0,1-.6.05c-1,0-1.54-.54-1.54-1.63v-2.76h-.71V368l.76-.39.37-1.09h.67v1.14h1.46v.83h-1.46v2.74a.79.79,0,0,0,.2.59A.72.72,0,0,0,504.87,372Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.7,366.28a.61.61,0,0,1,.16-.45.63.63,0,0,1,.45-.16.61.61,0,0,1,.45.16.61.61,0,0,1,.16.45.55.55,0,0,1-.61.6.59.59,0,0,1-.45-.16A.58.58,0,0,1,506.7,366.28Zm1.15,6.49h-1.09v-5.13h1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,371.31a1.32,1.32,0,0,1-.55,1.15,2.6,2.6,0,0,1-1.57.4,3.63,3.63,0,0,1-1.64-.31v-.94a4,4,0,0,0,1.68.42c.67,0,1-.2,1-.61a.48.48,0,0,0-.11-.32,1.31,1.31,0,0,0-.37-.27,7.64,7.64,0,0,0-.71-.32,3.31,3.31,0,0,1-1.2-.68,1.27,1.27,0,0,1-.31-.89,1.18,1.18,0,0,1,.53-1,2.51,2.51,0,0,1,1.44-.36,4,4,0,0,1,1.71.37l-.35.82a3.8,3.8,0,0,0-1.39-.35c-.58,0-.87.17-.87.49a.49.49,0,0,0,.23.41,4.83,4.83,0,0,0,1,.46,5.24,5.24,0,0,1,.92.45,1.36,1.36,0,0,1,.43.47A1.41,1.41,0,0,1,513,371.31Z",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "AssayLegends"
  }, /*#__PURE__*/React.createElement("g", {
    className: "BLOOD",
    "data-name": "BLOOD"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    x: 542.93,
    y: 147.14,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  })), /*#__PURE__*/React.createElement("g", {
    className: "PLASMA",
    "data-name": "PLASMA"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    cx: 548.53,
    cy: 176.19,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    cx: 563.32,
    cy: 176.19,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "HEART",
    "data-name": "HEART"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rrbs",
    cx: 7.3,
    cy: 140.03,
    r: 5.6,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    points: "21.72 134.46 15.28 145.6 28.15 145.6 21.72 134.46",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 31.74,
    y: 134.43,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prot-pr",
    cx: 52.32,
    cy: 140.03,
    r: 5.6,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.51,
    cy: 140.03,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.3,
    cy: 140.03,
    r: 5.6,
    fill: "#e78ac3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ph",
    points: "66.75 134.46 60.31 145.6 73.18 145.6 66.75 134.46",
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "prot-ac",
    x: 76.77,
    y: 134.43,
    width: 11.2,
    height: 11.2,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ub",
    points: "97.44 134.43 91.55 138.71 93.8 145.63 101.08 145.63 103.33 138.71 97.44 134.43",
    fill: "#8da0cb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "VENACV",
    "data-name": "VENACV"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 121.7,
    y: 175.96,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  })), /*#__PURE__*/React.createElement("g", {
    className: "SPLEEN",
    "data-name": "SPLEEN"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 542.94,
    y: 249.56,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.53,
    cy: 255.16,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 578.32,
    cy: 255.16,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "SKM-GN",
    "data-name": "SKM-GN"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rrbs",
    "data-name": "rrbs",
    cx: 548.53,
    cy: 410.57,
    r: 5.6,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "562.95 405 556.52 416.14 569.39 416.14 562.95 405",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 572.97,
    y: 404.97,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prot-pr",
    "data-name": "prot-pr",
    cx: 593.56,
    cy: 410.57,
    r: 5.6,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 623.6,
    cy: 410.57,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 638.39,
    cy: 410.57,
    r: 5.6,
    fill: "#e78ac3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ph",
    "data-name": "prot-ph",
    points: "607.98 405 601.55 416.14 614.41 416.14 607.98 405",
    fill: "#8da0cb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "SKM-VL",
    "data-name": "SKM-VL"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 543.04,
    y: 384.3,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.63,
    cy: 389.9,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 578.42,
    cy: 389.9,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "WAT-SC",
    "data-name": "WAT-SC"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rrbs",
    "data-name": "rrbs",
    cx: 37.48,
    cy: 383.42,
    r: 5.6,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "51.9 377.85 45.46 388.99 58.33 388.99 51.9 377.85",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 61.92,
    y: 377.82,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prot-pr",
    "data-name": "prot-pr",
    cx: 82.5,
    cy: 383.42,
    r: 5.6,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.6,
    cy: 383.42,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.39,
    cy: 383.42,
    r: 5.6,
    fill: "#e78ac3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ph",
    "data-name": "prot-ph",
    points: "96.92 377.85 90.49 388.99 103.36 388.99 96.92 377.85",
    fill: "#8da0cb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "BAT",
    "data-name": "BAT"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rrbs",
    "data-name": "rrbs",
    cx: 67.49,
    cy: 118.98,
    r: 5.6,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "81.91 113.41 75.48 124.55 88.34 124.55 81.91 113.41",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 91.93,
    y: 113.38,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.6,
    cy: 118.98,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.39,
    cy: 118.98,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "LIVER",
    "data-name": "LIVER"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rrbs",
    "data-name": "rrbs",
    cx: 7.3,
    cy: 214.51,
    r: 5.6,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "21.72 208.94 15.28 220.08 28.15 220.08 21.72 208.94",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 31.74,
    y: 208.91,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prot-pr",
    "data-name": "prot-pr",
    cx: 52.32,
    cy: 214.51,
    r: 5.6,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.51,
    cy: 214.51,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.3,
    cy: 214.51,
    r: 5.6,
    fill: "#e78ac3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ph",
    "data-name": "prot-ph",
    points: "66.75 208.94 60.31 220.08 73.18 220.08 66.75 208.94",
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "prot-ac",
    "data-name": "prot-ac",
    x: 76.77,
    y: 208.91,
    width: 11.2,
    height: 11.2,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ub",
    "data-name": "prot-ub",
    points: "97.44 208.91 91.55 213.19 93.8 220.11 101.08 220.11 103.33 213.19 97.44 208.91",
    fill: "#8da0cb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "LUNG",
    "data-name": "LUNG"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "53.3 155.58 46.87 166.72 59.74 166.72 53.3 155.58",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 63.33,
    y: 155.55,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prot-pr",
    "data-name": "prot-pr",
    cx: 83.91,
    cy: 161.15,
    r: 5.6,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.6,
    cy: 161.15,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.39,
    cy: 161.15,
    r: 5.6,
    fill: "#e78ac3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ph",
    "data-name": "prot-ph",
    points: "98.33 155.58 91.9 166.72 104.77 166.72 98.33 155.58",
    fill: "#8da0cb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "KIDNEY",
    "data-name": "KIDNEY"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rrbs",
    "data-name": "rrbs",
    cx: 548.53,
    cy: 315.5,
    r: 5.6,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "562.95 309.93 556.52 321.07 569.39 321.07 562.95 309.93",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 572.97,
    y: 309.9,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prot-pr",
    "data-name": "prot-pr",
    cx: 593.56,
    cy: 315.5,
    r: 5.6,
    fill: "#8da0cb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 623.6,
    cy: 315.5,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 638.39,
    cy: 315.5,
    r: 5.6,
    fill: "#e78ac3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "prot-ph",
    "data-name": "prot-ph",
    points: "607.98 309.93 601.55 321.07 614.41 321.07 607.98 309.93",
    fill: "#8da0cb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ADRNL",
    "data-name": "ADRNL"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 543.04,
    y: 288.79,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.63,
    cy: 294.39,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 578.42,
    cy: 294.39,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "CORTEX",
    "data-name": "CORTEX"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 542.94,
    y: 39.22,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.53,
    cy: 44.82,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 578.32,
    cy: 44.82,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "HYPOTH",
    "data-name": "HYPOTH"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 542.94,
    y: 58.1,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.53,
    cy: 63.7,
    r: 5.6,
    fill: "#66c2a5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "HIPPOC",
    "data-name": "HIPPOC"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "atac-seq",
    "data-name": "atac-seq",
    points: "81.76 49.09 75.33 60.24 88.2 60.24 81.76 49.09",
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 91.78,
    y: 49.07,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.6,
    cy: 54.67,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.39,
    cy: 54.67,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "SMLINT",
    "data-name": "SMLINT"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 91.93,
    y: 277.47,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.6,
    cy: 283.07,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.39,
    cy: 283.07,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "COLON",
    "data-name": "COLON"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 91.93,
    y: 354.87,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 112.6,
    cy: 360.47,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 127.39,
    cy: 360.47,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "OVARY",
    "data-name": "OVARY"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 542.94,
    y: 334.5,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.53,
    cy: 340.1,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 578.32,
    cy: 340.1,
    r: 5.6,
    fill: "#e78ac3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "TESTES",
    "data-name": "TESTES"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rna-seq",
    "data-name": "rna-seq",
    x: 542.94,
    y: 363.64,
    width: 11.2,
    height: 11.2,
    fill: "#fc8d62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "metab",
    "data-name": "metab",
    cx: 563.53,
    cy: 369.24,
    r: 5.6,
    fill: "#66c2a5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cytokine",
    "data-name": "cytokine",
    cx: 578.32,
    cy: 369.24,
    r: 5.6,
    fill: "#e78ac3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatFigurePass1B);
export default __webpack_public_path__ + "static/media/rat-figure-pass1b.f29e6bc9f2b2475aae600324359b748d.svg";
export { ForwardRef as ReactComponent };